import { Alert as Alert$1, Badge as Badge$1, Breadcrumb as Breadcrumb$1, Button as Button$1, Card as Card$1, CardBody as CardBody$1, CardTitle as CardTitle$1, CardText as CardText$1, Collapse as Collapse$1, Container, Row, Col, NavbarBrand, Navbar, NavbarToggler, Nav as Nav$1, NavItem, UncontrolledDropdown, DropdownToggle, DropdownMenu, Dropdown, Modal as Modal$1, ModalBody as ModalBody$1, ModalFooter as ModalFooter$1, PaginationItem, PaginationLink, FormGroup, Input as Input$1, Label, Form, CardHeader } from 'reactstrap';
export { BreadcrumbItem, ButtonDropdown, ButtonGroup, ButtonToolbar, CardColumns, CardDeck, CardFooter, CardGroup, CardHeader, CardImg, CardImgOverlay, CardLink, CardSubtitle, Col, Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Fade, Form, FormFeedback, FormGroup, FormText, InputGroup, InputGroupText, Label, ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText, Media, NavItem, NavLink, Navbar, NavbarBrand, NavbarToggler, PaginationItem as PagerItem, PaginationLink as PagerLink, Popover, PopoverBody, PopoverHeader, Row, TabContent, TabPane, Table, Tooltip, UncontrolledAlert, UncontrolledButtonDropdown, UncontrolledCollapse, UncontrolledDropdown, UncontrolledTooltip, Util } from 'reactstrap';
export { useNavScroll } from 'react-use-navscroll';
import React__default, { useState, useCallback, useEffect, createContext, useContext, Component, Fragment, createElement } from 'react';
import classNames from 'classnames';
import { Transition } from 'react-transition-group';
import { Link, NavLink } from 'react-router-dom';
import parse from 'html-react-parser';
import { StickyProvider, Sticky } from 'react-stickup';
import isNumber from 'is-number';
import SelectBase, { components } from 'react-select';
import { useToast, cssTransition, useToastContainer, toast } from 'react-toastify';
import { render } from 'react-dom';

var defaultProps = {
  color: 'success',
  isOpen: true,
  fade: true
};
var Alert = function Alert(props) {
  return React__default.createElement(Alert$1, Object.assign({}, props));
};
Alert.defaultProps = defaultProps;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

var Accordion = function Accordion(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      className = _ref.className,
      background = _ref.background,
      _ref$iconLeft = _ref.iconLeft,
      iconLeft = _ref$iconLeft === void 0 ? false : _ref$iconLeft,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "className", "background", "iconLeft"]);

  var Tag = tag;
  var classes = classNames('accordion', className, {
    'accordion-background-active': background === 'active',
    'accordion-background-hover': background === 'hover',
    'accordion-left-icon': iconLeft
  });
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: classes
  }));
};

var AccordionItem = function AccordionItem(_ref) {
  var className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className"]);

  var classes = classNames('accordion-item', className);
  return React__default.createElement("div", Object.assign({}, attributes, {
    className: classes
  }));
};

var AccordionHeader = function AccordionHeader(_ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'button' : _ref$tag,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      append = _ref.append,
      onToggle = _ref.onToggle,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag", "type", "active", "append", "onToggle"]);

  var Tag = tag;
  var toggleClasses = classNames('accordion-button', className, {
    collapsed: active
  });
  return React__default.createElement("div", {
    className: 'accordion-header'
  }, React__default.createElement(Tag, Object.assign({
    type: type,
    "data-toggle": 'collapse',
    "aria-expanded": active ? 'true' : 'false',
    className: toggleClasses,
    onClick: onToggle
  }, attributes)), append);
};

var noop = function noop() {};
var logError = function logError(message) {
  if (typeof console !== 'undefined') {
    if (console.error) {
      console.error(message);
    } else {
      console.log(message);
    }
  }
}; // @internal Used for testing purposes only
var messages = {};
var notifyDeprecation = function notifyDeprecation(message, options) {
  if (options === void 0) {
    options = {
      once: true
    };
  }

  if (!options.once) {
    logError(message);
  } else {
    if (!messages[message]) {
      logError(message);
      messages[message] = 1;
    }
  }
};
function mapToCssModules(className, cssModules) {
  var finalClassNames = className == null ? '' : className;

  if (!cssModules) {
    return finalClassNames;
  }

  return finalClassNames.split(' ').map(function (klass) {
    var _cssModules$klass;

    return (_cssModules$klass = cssModules[klass]) != null ? _cssModules$klass : klass;
  }).join(' ');
}
function pick(obj, keys) {
  var keysArray = Array.isArray(keys) ? keys : [keys];
  var newObj = {};

  for (var _iterator = _createForOfIteratorHelperLoose(keysArray), _step; !(_step = _iterator()).done;) {
    var key = _step.value;

    if (key in obj) {
      newObj[key] = obj[key];
    }
  }

  return newObj;
}
function omit(obj, keys) {
  var keysLookup = new Set(Array.isArray(keys) ? keys : [keys]);
  var newObj = {};

  for (var key in obj) {
    if (!keysLookup.has(key)) {
      newObj[key] = obj[key];
    }
  }

  return newObj;
}

// Taken from Reactstrap utils.js which are tken from bootstrap sass
var TransitionTimeouts = {
  // $transition-fade
  Fade: 150,
  // $transition-collapse
  Collapse: 350,
  // $modal-transition
  Modal: 300,
  // $carousel-transition
  Carousel: 600
}; // taken from Reactstrap utils.js

var TransitionsKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];

var transitionStatusToClassHash = {
  entering: 'collapsing',
  entered: 'collapse show',
  exiting: 'collapsing',
  exited: 'collapse'
};

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var AccordionBody = function AccordionBody(_ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      children = _ref.children,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? TransitionTimeouts.Collapse : _ref$timeout,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag", "active", "children", "timeout"]);

  var _useState = useState(null),
      height = _useState[0],
      setHeight = _useState[1];

  var onEntering = useCallback(function (node, isAppearing) {
    setHeight(getHeight(node));
    attributes.onEntering == null ? void 0 : attributes.onEntering(node, isAppearing);
  }, [attributes.onEntering]);
  var onEntered = useCallback(function (node, isAppearing) {
    setHeight(null);
    attributes.onEntered == null ? void 0 : attributes.onEntered(node, isAppearing);
  }, [attributes.onEntered]);
  var onExit = useCallback(function (node) {
    setHeight(getHeight(node));
    attributes.onExit == null ? void 0 : attributes.onExit(node);
  }, [attributes.onExit]);
  var onExiting = useCallback(function (node) {
    setHeight(0);
    attributes.onExiting == null ? void 0 : attributes.onExiting(node);
  }, [attributes.onExiting]);
  var onExited = useCallback(function (node) {
    setHeight(null);
    attributes.onExited == null ? void 0 : attributes.onExited(node);
  }, [attributes.onExited]);
  var Tag = tag;
  var transitionProps = pick(attributes, TransitionsKeys);
  var childProps = omit(attributes, TransitionsKeys);
  return React__default.createElement(Transition, Object.assign({}, transitionProps, {
    timeout: timeout,
    in: active,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited
  }), function (status) {
    var transitionClass = getTransitionClass(status);
    var classes = classNames(className, transitionClass);
    var style = height == null ? null : {
      height: height
    };
    return React__default.createElement(Tag, Object.assign({
      className: classes,
      style: _extends({}, childProps.style, style)
    }, childProps), React__default.createElement("div", {
      className: 'accordion-collapse collapse show'
    }, children));
  });
}; // }

var AvatarContainer = function AvatarContainer(_ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag"]);

  var Tag = tag;
  var wrapperClasses = classNames('d-flex align-items-center justify-content-around flex-wrap flex-sm-nowrap', className);
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: wrapperClasses
  }));
};

var AvatarGroupContainer = function AvatarGroupContainer(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'ul' : _ref$tag,
      wrapperClassName = _ref.wrapperClassName,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag", "wrapperClassName"]);

  var Tag = tag;
  var wrapperClasses = classNames('avatar-group-stacked', wrapperClassName);
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: wrapperClasses
  }));
};

var AvatarExtraText = function AvatarExtraText(_ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag"]);

  var Tag = tag;
  var wrapperClass = classNames('extra-text', className);
  return React__default.createElement(Tag, Object.assign({
    className: wrapperClass
  }, attributes));
};

var AvatarIcon = function AvatarIcon(_ref) {
  var _classNames;

  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      href = _ref.href,
      color = _ref.color,
      innerRef = _ref.innerRef,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag", "size", "href", "color", "innerRef", "children"]);

  var Tag = tag;
  var typeClass = classNames('avatar', (_classNames = {}, _classNames["size-" + size] = size, _classNames["avatar-" + color] = color, _classNames));

  if (href) {
    return React__default.createElement("a", Object.assign({
      href: href
    }, attributes, {
      className: typeClass,
      ref: innerRef
    }), children);
  }

  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: typeClass
  }), children);
};

var AvatarPresence = function AvatarPresence(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      presence = _ref.presence,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag", "presence"]);

  var Tag = tag;
  var typeClass = classNames('avatar-presence', {
    presence: presence
  });
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: typeClass
  }));
};

var AvatarStatus = function AvatarStatus(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      status = _ref.status,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag", "status"]);

  var Tag = tag;
  var typeClass = classNames('avatar-status', {
    status: status
  });
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: typeClass
  }));
};

var AvatarWrapper = function AvatarWrapper(_ref) {
  var _classNames;

  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      extra = _ref.extra,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag", "extra"]);

  var Tag = tag;
  var wrapperClass = classNames('avatar-wrapper', className, (_classNames = {}, _classNames["avatar-extra-" + extra] = extra, _classNames));
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: wrapperClass
  }));
};

var Badge = function Badge(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'secondary' : _ref$color,
      _ref$pill = _ref.pill,
      pill = _ref$pill === void 0 ? false : _ref$pill,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'span' : _ref$tag,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["color", "pill", "tag", "children"]);

  return React__default.createElement(Badge$1, Object.assign({
    className: "bg-" + color + (pill ? ' rounded-pill' : '') + (color === 'light' ? ' text-primary' : ''),
    color: '',
    tag: tag
  }, attributes), children);
};

var Breadcrumb = function Breadcrumb(_ref) {
  var className = _ref.className,
      listClassName = _ref.listClassName,
      dark = _ref.dark,
      label = _ref['aria-label'],
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "listClassName", "dark", "aria-label"]);

  var classes = classNames(className, 'breadcrumb-container');
  var listClasses = classNames(listClassName, {
    dark: dark
  });
  var ariaLabel = label != null ? label : 'breadcrumb';
  return React__default.createElement(Breadcrumb$1, Object.assign({
    className: classes,
    listClassName: listClasses,
    "aria-label": ariaLabel
  }, attributes));
};

var Button = function Button(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'button' : _ref$tag,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? false : _ref$icon,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "icon", "color", "className"]);

  var classes = classNames(className, {
    'btn-icon': icon
  });

  var ariaAttributes = _extends({}, attributes.disabled && {
    'aria-disabled': true
  });

  var baseProps = {
    color: color,
    tag: tag
  };
  return React__default.createElement(Button$1, Object.assign({
    className: classes
  }, baseProps, attributes, ariaAttributes));
};

var Forward = function Forward(_ref) {
  var className = _ref.className,
      scrollToRef = _ref.scrollToRef,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "scrollToRef", "children"]);

  var classes = classNames(className, 'forward');
  return React__default.createElement("a", Object.assign({
    className: classes,
    onClick: function onClick() {
      var _scrollToRef$current;

      return (_scrollToRef$current = scrollToRef.current) == null ? void 0 : _scrollToRef$current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, attributes), children);
};

var Callout = function Callout(_ref) {
  var children = _ref.children,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$highlight = _ref.highlight,
      highlight = _ref$highlight === void 0 ? false : _ref$highlight,
      detailed = _ref.detailed,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["children", "color", "highlight", "detailed", "tag"]);

  var Tag = tag;
  var classes = classNames('callout', color, {
    'callout-highlight': highlight,
    'callout-more': detailed
  });
  return React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes), children);
};

var CalloutText = function CalloutText(_ref) {
  var _ref$bigText = _ref.bigText,
      bigText = _ref$bigText === void 0 ? false : _ref$bigText,
      children = _ref.children,
      className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'p' : _ref$tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["bigText", "children", "className", "tag"]);

  var Tag = tag;
  var classes = classNames(className, {
    'callout-big-text': bigText
  });
  return React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes), children);
};

var CalloutTitle = function CalloutTitle(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["children", "className", "tag"]);

  var Tag = tag;
  var classes = classNames(className, 'callout-title');
  return React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes), children);
};

var Card = function Card(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      teaser = _ref.teaser,
      spacing = _ref.spacing,
      _ref$noWrapper = _ref.noWrapper,
      noWrapper = _ref$noWrapper === void 0 ? false : _ref$noWrapper,
      wrapperClassName = _ref.wrapperClassName,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "teaser", "spacing", "noWrapper", "wrapperClassName"]);

  var wrapperClasses = classNames('card-wrapper', wrapperClassName, {
    'card-space': spacing,
    'card-teaser-wrapper': teaser
  });
  var cardClasses = classNames(attributes.className, {
    'card-teaser': teaser
  });

  if (noWrapper) {
    return React__default.createElement(Card$1, Object.assign({}, attributes, {
      className: cardClasses,
      tag: tag
    }));
  }

  return React__default.createElement("div", {
    className: wrapperClasses
  }, React__default.createElement(Card$1, Object.assign({}, attributes, {
    className: cardClasses,
    tag: tag
  })));
};

var CardBody = function CardBody(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      props = _objectWithoutPropertiesLoose(_ref, ["tag"]);

  return React__default.createElement(CardBody$1, Object.assign({}, props, {
    tag: tag
  }));
};

var CardTitle = function CardTitle(props) {
  return React__default.createElement(CardTitle$1, Object.assign({}, props));
};

var CardText = function CardText(props) {
  return React__default.createElement(CardText$1, Object.assign({}, props));
};

var iconList = {
  'it-arrow-down-circle': true,
  'it-arrow-down-triangle': true,
  'it-arrow-down': true,
  'it-arrow-left-circle': true,
  'it-arrow-left-triangle': true,
  'it-arrow-left': true,
  'it-arrow-right-circle': true,
  'it-arrow-right-triangle': true,
  'it-arrow-right': true,
  'it-arrow-up-circle': true,
  'it-arrow-up-triangle': true,
  'it-arrow-up': true,
  'it-ban': true,
  'it-behance': true,
  'it-bookmark': true,
  'it-box': true,
  'it-burger': true,
  'it-calendar': true,
  'it-camera': true,
  'it-card': true,
  'it-chart-line': true,
  'it-check-circle': true,
  'it-check': true,
  'it-chevron-left': true,
  'it-chevron-right': true,
  'it-clip': true,
  'it-clock': true,
  'it-close-big': true,
  'it-close-circle': true,
  'it-close': true,
  'it-code-circle': true,
  'it-collapse': true,
  'it-comment': true,
  'it-copy': true,
  'it-delete': true,
  'it-designers-italia': true,
  'it-download': true,
  'it-error': true,
  'it-exchange-circle': true,
  'it-expand': true,
  'it-external-link': true,
  'it-facebook-square': true,
  'it-facebook': true,
  'it-figma-square': true,
  'it-figma': true,
  'it-file-audio': true,
  'it-file-compressed': true,
  'it-file-csv': true,
  'it-file-json': true,
  'it-file-odp': true,
  'it-file-ods': true,
  'it-file-odt': true,
  'it-file-pdf-ext': true,
  'it-file-pdf': true,
  'it-file-sheet': true,
  'it-file-slides': true,
  'it-file-txt': true,
  'it-file-video': true,
  'it-file-xml': true,
  'it-file': true,
  'it-files': true,
  'it-flag': true,
  'it-flickr-square': true,
  'it-flickr': true,
  'it-folder': true,
  'it-fullscreen': true,
  'it-funnel': true,
  'it-github': true,
  'it-google': true,
  'it-hearing': true,
  'it-help-circle': true,
  'it-help': true,
  'it-horn': true,
  'it-inbox': true,
  'it-info-circle': true,
  'it-instagram': true,
  'it-key': true,
  'it-less-circle': true,
  'it-link': true,
  'it-linkedin-square': true,
  'it-linkedin': true,
  'it-list': true,
  'it-lock': true,
  'it-locked': true,
  'it-logout': true,
  'it-mail-open': true,
  'it-mail': true,
  'it-map-marker-circle': true,
  'it-map-marker-minus': true,
  'it-map-marker-plus': true,
  'it-map-marker': true,
  'it-mastodon-square': true,
  'it-mastodon': true,
  'it-maximize-alt': true,
  'it-maximize': true,
  'it-medium-square': true,
  'it-medium': true,
  'it-minimize': true,
  'it-minus-circle': true,
  'it-minus': true,
  'it-more-actions': true,
  'it-more-items': true,
  'it-note': true,
  'it-open-source': true,
  'it-pa': true,
  'it-password-invisible': true,
  'it-password-visible': true,
  'it-pencil': true,
  'it-piattaforme': true,
  'it-pin': true,
  'it-pinterest-square': true,
  'it-pinterest': true,
  'it-plug': true,
  'it-plus-circle': true,
  'it-plus': true,
  'it-presentation': true,
  'it-print': true,
  'it-quora-square': true,
  'it-quora': true,
  'it-reddit-square': true,
  'it-reddit': true,
  'it-refresh': true,
  'it-restore': true,
  'it-rss-square': true,
  'it-rss': true,
  'it-search': true,
  'it-settings': true,
  'it-share': true,
  'it-slack-square': true,
  'it-slack': true,
  'it-snapchat-square': true,
  'it-snapchat': true,
  'it-software': true,
  'it-stackexchange-square': true,
  'it-stackexchange': true,
  'it-stackoverflow-square': true,
  'it-stackoverflow': true,
  'it-star-full': true,
  'it-star-outline': true,
  'it-team-digitale': true,
  'it-telegram': true,
  'it-telephone': true,
  'it-tiktok-square': true,
  'it-tiktok': true,
  'it-tool': true,
  'it-twitter-square': true,
  'it-twitter': true,
  'it-unlocked': true,
  'it-upload': true,
  'it-user': true,
  'it-video': true,
  'it-vimeo-square': true,
  'it-vimeo': true,
  'it-warning-circle': true,
  'it-warning': true,
  'it-whatsapp-square': true,
  'it-whatsapp': true,
  'it-wifi': true,
  'it-youtube': true,
  'it-zoom-in': true,
  'it-zoom-out': true
};
var loadIcon = function loadIcon(name) {
  switch (name) {
    case 'it-arrow-down-circle':
      {
        return import('./ItArrowDownCircle-36c90b4e.js');
      }

    case 'it-arrow-down-triangle':
      {
        return import('./ItArrowDownTriangle-26b93125.js');
      }

    case 'it-arrow-down':
      {
        return import('./ItArrowDown-13455c5e.js');
      }

    case 'it-arrow-left-circle':
      {
        return import('./ItArrowLeftCircle-85b41ded.js');
      }

    case 'it-arrow-left-triangle':
      {
        return import('./ItArrowLeftTriangle-66ae1f4e.js');
      }

    case 'it-arrow-left':
      {
        return import('./ItArrowLeft-2f1da4b8.js');
      }

    case 'it-arrow-right-circle':
      {
        return import('./ItArrowRightCircle-4e5a363d.js');
      }

    case 'it-arrow-right-triangle':
      {
        return import('./ItArrowRightTriangle-c5c171ad.js');
      }

    case 'it-arrow-right':
      {
        return import('./ItArrowRight-e600c1f2.js');
      }

    case 'it-arrow-up-circle':
      {
        return import('./ItArrowUpCircle-537c9b21.js');
      }

    case 'it-arrow-up-triangle':
      {
        return import('./ItArrowUpTriangle-86464703.js');
      }

    case 'it-arrow-up':
      {
        return import('./ItArrowUp-4b52693b.js');
      }

    case 'it-ban':
      {
        return import('./ItBan-25067a0a.js');
      }

    case 'it-behance':
      {
        return import('./ItBehance-0d61a4b7.js');
      }

    case 'it-bookmark':
      {
        return import('./ItBookmark-7483e19c.js');
      }

    case 'it-box':
      {
        return import('./ItBox-89b6e19f.js');
      }

    case 'it-burger':
      {
        return import('./ItBurger-a4708eb4.js');
      }

    case 'it-calendar':
      {
        return import('./ItCalendar-9b915ca9.js');
      }

    case 'it-camera':
      {
        return import('./ItCamera-82209c75.js');
      }

    case 'it-card':
      {
        return import('./ItCard-92138e1c.js');
      }

    case 'it-chart-line':
      {
        return import('./ItChartLine-22f98dba.js');
      }

    case 'it-check-circle':
      {
        return import('./ItCheckCircle-0b9d1001.js');
      }

    case 'it-check':
      {
        return import('./ItCheck-d7bf9823.js');
      }

    case 'it-chevron-left':
      {
        return import('./ItChevronLeft-9e6f642c.js');
      }

    case 'it-chevron-right':
      {
        return import('./ItChevronRight-5d8994f9.js');
      }

    case 'it-clip':
      {
        return import('./ItClip-56208296.js');
      }

    case 'it-clock':
      {
        return import('./ItClock-4f4b280c.js');
      }

    case 'it-close-big':
      {
        return import('./ItCloseBig-3739e281.js');
      }

    case 'it-close-circle':
      {
        return import('./ItCloseCircle-cd71362b.js');
      }

    case 'it-close':
      {
        return import('./ItClose-a9bffab7.js');
      }

    case 'it-code-circle':
      {
        return import('./ItCodeCircle-cc967ef2.js');
      }

    case 'it-collapse':
      {
        return import('./ItCollapse-7eeb99ff.js');
      }

    case 'it-comment':
      {
        return import('./ItComment-a701c30b.js');
      }

    case 'it-copy':
      {
        return import('./ItCopy-c4afc1e5.js');
      }

    case 'it-delete':
      {
        return import('./ItDelete-19ed8211.js');
      }

    case 'it-designers-italia':
      {
        return import('./ItDesignersItalia-430296c2.js');
      }

    case 'it-download':
      {
        return import('./ItDownload-df99e1cc.js');
      }

    case 'it-error':
      {
        return import('./ItError-92a82cd6.js');
      }

    case 'it-exchange-circle':
      {
        return import('./ItExchangeCircle-929aa244.js');
      }

    case 'it-expand':
      {
        return import('./ItExpand-b9bf051e.js');
      }

    case 'it-external-link':
      {
        return import('./ItExternalLink-e167df18.js');
      }

    case 'it-facebook-square':
      {
        return import('./ItFacebookSquare-d9731526.js');
      }

    case 'it-facebook':
      {
        return import('./ItFacebook-620bfcd2.js');
      }

    case 'it-figma-square':
      {
        return import('./ItFigmaSquare-39f05dbe.js');
      }

    case 'it-figma':
      {
        return import('./ItFigma-ebc0db60.js');
      }

    case 'it-file-audio':
      {
        return import('./ItFileAudio-bed6e1df.js');
      }

    case 'it-file-compressed':
      {
        return import('./ItFileCompressed-36fc5ffa.js');
      }

    case 'it-file-csv':
      {
        return import('./ItFileCsv-e621a8d7.js');
      }

    case 'it-file-json':
      {
        return import('./ItFileJson-5c19cac5.js');
      }

    case 'it-file-odp':
      {
        return import('./ItFileOdp-3903a2f3.js');
      }

    case 'it-file-ods':
      {
        return import('./ItFileOds-0b715f94.js');
      }

    case 'it-file-odt':
      {
        return import('./ItFileOdt-a55010f2.js');
      }

    case 'it-file-pdf-ext':
      {
        return import('./ItFilePdfExt-3f3ad3b3.js');
      }

    case 'it-file-pdf':
      {
        return import('./ItFilePdf-26adf06c.js');
      }

    case 'it-file-sheet':
      {
        return import('./ItFileSheet-55a0d582.js');
      }

    case 'it-file-slides':
      {
        return import('./ItFileSlides-926d58be.js');
      }

    case 'it-file-txt':
      {
        return import('./ItFileTxt-8e631a68.js');
      }

    case 'it-file-video':
      {
        return import('./ItFileVideo-b9b7281e.js');
      }

    case 'it-file-xml':
      {
        return import('./ItFileXml-f8de8849.js');
      }

    case 'it-file':
      {
        return import('./ItFile-fed4aa3b.js');
      }

    case 'it-files':
      {
        return import('./ItFiles-0b03c3b3.js');
      }

    case 'it-flag':
      {
        return import('./ItFlag-55842199.js');
      }

    case 'it-flickr-square':
      {
        return import('./ItFlickrSquare-757c54c5.js');
      }

    case 'it-flickr':
      {
        return import('./ItFlickr-c1ec1f7d.js');
      }

    case 'it-folder':
      {
        return import('./ItFolder-b59a093e.js');
      }

    case 'it-fullscreen':
      {
        return import('./ItFullscreen-3b43c6cc.js');
      }

    case 'it-funnel':
      {
        return import('./ItFunnel-5a10e8e5.js');
      }

    case 'it-github':
      {
        return import('./ItGithub-1e05721d.js');
      }

    case 'it-google':
      {
        return import('./ItGoogle-e8139cf5.js');
      }

    case 'it-hearing':
      {
        return import('./ItHearing-536f3d26.js');
      }

    case 'it-help-circle':
      {
        return import('./ItHelpCircle-0735dbe6.js');
      }

    case 'it-help':
      {
        return import('./ItHelp-22697d28.js');
      }

    case 'it-horn':
      {
        return import('./ItHorn-0a27ee34.js');
      }

    case 'it-inbox':
      {
        return import('./ItInbox-87de0d4f.js');
      }

    case 'it-info-circle':
      {
        return import('./ItInfoCircle-c304e7be.js');
      }

    case 'it-instagram':
      {
        return import('./ItInstagram-49121272.js');
      }

    case 'it-key':
      {
        return import('./ItKey-8218f8db.js');
      }

    case 'it-less-circle':
      {
        return import('./ItLessCircle-a9976d1f.js');
      }

    case 'it-link':
      {
        return import('./ItLink-052ea6a6.js');
      }

    case 'it-linkedin-square':
      {
        return import('./ItLinkedinSquare-5d2e4369.js');
      }

    case 'it-linkedin':
      {
        return import('./ItLinkedin-bdd358f6.js');
      }

    case 'it-list':
      {
        return import('./ItList-23312a06.js');
      }

    case 'it-lock':
      {
        return import('./ItLock-1e0db16b.js');
      }

    case 'it-locked':
      {
        return import('./ItLocked-bc50b228.js');
      }

    case 'it-logout':
      {
        return import('./ItLogout-5d9bf86f.js');
      }

    case 'it-mail-open':
      {
        return import('./ItMailOpen-0a260517.js');
      }

    case 'it-mail':
      {
        return import('./ItMail-ec2fe8be.js');
      }

    case 'it-map-marker-circle':
      {
        return import('./ItMapMarkerCircle-a9d7234a.js');
      }

    case 'it-map-marker-minus':
      {
        return import('./ItMapMarkerMinus-2aa866ac.js');
      }

    case 'it-map-marker-plus':
      {
        return import('./ItMapMarkerPlus-e8f358ff.js');
      }

    case 'it-map-marker':
      {
        return import('./ItMapMarker-883fa315.js');
      }

    case 'it-mastodon-square':
      {
        return import('./ItMastodonSquare-93cd85d7.js');
      }

    case 'it-mastodon':
      {
        return import('./ItMastodon-5c9c1509.js');
      }

    case 'it-maximize-alt':
      {
        return import('./ItMaximizeAlt-df597890.js');
      }

    case 'it-maximize':
      {
        return import('./ItMaximize-74911e38.js');
      }

    case 'it-medium-square':
      {
        return import('./ItMediumSquare-da755d45.js');
      }

    case 'it-medium':
      {
        return import('./ItMedium-73bf12bf.js');
      }

    case 'it-minimize':
      {
        return import('./ItMinimize-8706d873.js');
      }

    case 'it-minus-circle':
      {
        return import('./ItMinusCircle-57aaf35e.js');
      }

    case 'it-minus':
      {
        return import('./ItMinus-80d84193.js');
      }

    case 'it-more-actions':
      {
        return import('./ItMoreActions-a3f80ebd.js');
      }

    case 'it-more-items':
      {
        return import('./ItMoreItems-cbde47d5.js');
      }

    case 'it-note':
      {
        return import('./ItNote-7f40f20e.js');
      }

    case 'it-open-source':
      {
        return import('./ItOpenSource-4fd13ee9.js');
      }

    case 'it-pa':
      {
        return import('./ItPa-5fb27aee.js');
      }

    case 'it-password-invisible':
      {
        return import('./ItPasswordInvisible-86329f6e.js');
      }

    case 'it-password-visible':
      {
        return import('./ItPasswordVisible-09af70c1.js');
      }

    case 'it-pencil':
      {
        return import('./ItPencil-0217fbdd.js');
      }

    case 'it-piattaforme':
      {
        return import('./ItPiattaforme-058b8285.js');
      }

    case 'it-pin':
      {
        return import('./ItPin-4c0a400a.js');
      }

    case 'it-pinterest-square':
      {
        return import('./ItPinterestSquare-a896f812.js');
      }

    case 'it-pinterest':
      {
        return import('./ItPinterest-3e760468.js');
      }

    case 'it-plug':
      {
        return import('./ItPlug-e7c32c08.js');
      }

    case 'it-plus-circle':
      {
        return import('./ItPlusCircle-ba6b894c.js');
      }

    case 'it-plus':
      {
        return import('./ItPlus-edfb7239.js');
      }

    case 'it-presentation':
      {
        return import('./ItPresentation-f02929f2.js');
      }

    case 'it-print':
      {
        return import('./ItPrint-0ad392a7.js');
      }

    case 'it-quora-square':
      {
        return import('./ItQuoraSquare-57abee58.js');
      }

    case 'it-quora':
      {
        return import('./ItQuora-166c812e.js');
      }

    case 'it-reddit-square':
      {
        return import('./ItRedditSquare-712d15c5.js');
      }

    case 'it-reddit':
      {
        return import('./ItReddit-4b476bfa.js');
      }

    case 'it-refresh':
      {
        return import('./ItRefresh-c17c06a0.js');
      }

    case 'it-restore':
      {
        return import('./ItRestore-f8212e23.js');
      }

    case 'it-rss-square':
      {
        return import('./ItRssSquare-f70f022e.js');
      }

    case 'it-rss':
      {
        return import('./ItRss-a406675c.js');
      }

    case 'it-search':
      {
        return import('./ItSearch-e7562298.js');
      }

    case 'it-settings':
      {
        return import('./ItSettings-52be00c7.js');
      }

    case 'it-share':
      {
        return import('./ItShare-85d38fc1.js');
      }

    case 'it-slack-square':
      {
        return import('./ItSlackSquare-f294e68b.js');
      }

    case 'it-slack':
      {
        return import('./ItSlack-835bf89c.js');
      }

    case 'it-snapchat-square':
      {
        return import('./ItSnapchatSquare-7a5c5ef8.js');
      }

    case 'it-snapchat':
      {
        return import('./ItSnapchat-a9a3d768.js');
      }

    case 'it-software':
      {
        return import('./ItSoftware-c7922563.js');
      }

    case 'it-stackexchange-square':
      {
        return import('./ItStackexchangeSquare-357dcdbe.js');
      }

    case 'it-stackexchange':
      {
        return import('./ItStackexchange-1a1e02db.js');
      }

    case 'it-stackoverflow-square':
      {
        return import('./ItStackoverflowSquare-421928c4.js');
      }

    case 'it-stackoverflow':
      {
        return import('./ItStackoverflow-bab99027.js');
      }

    case 'it-star-full':
      {
        return import('./ItStarFull-ca223ee9.js');
      }

    case 'it-star-outline':
      {
        return import('./ItStarOutline-00c85e83.js');
      }

    case 'it-team-digitale':
      {
        return import('./ItTeamDigitale-a5db822b.js');
      }

    case 'it-telegram':
      {
        return import('./ItTelegram-7bb55bce.js');
      }

    case 'it-telephone':
      {
        return import('./ItTelephone-04280df3.js');
      }

    case 'it-tiktok-square':
      {
        return import('./ItTiktokSquare-1b8adca7.js');
      }

    case 'it-tiktok':
      {
        return import('./ItTiktok-24f49198.js');
      }

    case 'it-tool':
      {
        return import('./ItTool-25a8ddb7.js');
      }

    case 'it-twitter-square':
      {
        return import('./ItTwitterSquare-dfd5fcd8.js');
      }

    case 'it-twitter':
      {
        return import('./ItTwitter-c92c2336.js');
      }

    case 'it-unlocked':
      {
        return import('./ItUnlocked-5c32257b.js');
      }

    case 'it-upload':
      {
        return import('./ItUpload-76def698.js');
      }

    case 'it-user':
      {
        return import('./ItUser-b65041d1.js');
      }

    case 'it-video':
      {
        return import('./ItVideo-de8eefa0.js');
      }

    case 'it-vimeo-square':
      {
        return import('./ItVimeoSquare-7915d97e.js');
      }

    case 'it-vimeo':
      {
        return import('./ItVimeo-553abf60.js');
      }

    case 'it-warning-circle':
      {
        return import('./ItWarningCircle-1aa638ec.js');
      }

    case 'it-warning':
      {
        return import('./ItWarning-ad2cb62a.js');
      }

    case 'it-whatsapp-square':
      {
        return import('./ItWhatsappSquare-dc22a0e5.js');
      }

    case 'it-whatsapp':
      {
        return import('./ItWhatsapp-8d153760.js');
      }

    case 'it-wifi':
      {
        return import('./ItWifi-2e6002fb.js');
      }

    case 'it-youtube':
      {
        return import('./ItYoutube-cd999b12.js');
      }

    case 'it-zoom-in':
      {
        return import('./ItZoomIn-1be027fa.js');
      }

    case 'it-zoom-out':
      {
        return import('./ItZoomOut-ae572666.js');
      }

    default:
      throw Error("It should not land here. Requested icon: \"" + name + "\"");
  }
};
function isBundledIcon(name) {
  return name in iconList;
}
var allIcons = /*#__PURE__*/Object.keys(iconList);

var EmptyIcon = function EmptyIcon(props) {
  return React__default.createElement("svg", Object.assign({
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24'
  }, props), React__default.createElement("path", {
    fill: 'none',
    d: 'M0 0h24v24H0z'
  }));
};

var iconsList = allIcons;
var iconsCache = {};
/**
 * Preload a list of icons in cache
 * @param icons - the list of icons to preload
 * @returns true if the icons have been preloaded
 */

function preloadIcons(icons) {
  return Promise.all(icons.map(function (icon) {
    return loadIcon(icon);
  })).then(function (preloadedIcons) {
    preloadedIcons.forEach(function (_ref, i) {
      var component = _ref.component;

      iconsCache[icons[i]] = function () {
        return component;
      };
    });
    return true;
  });
}
/**
 * Removes icons from cache
 * @param icon? - the icon to remove, or nothing to clear the whole cache
 * @returns an object containing the removed icons
 */

var clearIconCache = function clearIconCache(iconName) {
  var deletedItems;

  if (iconName) {
    var _deletedItems;

    deletedItems = (_deletedItems = {}, _deletedItems[iconName] = iconsCache[iconName], _deletedItems);
    delete iconsCache[iconName];
  } else {
    deletedItems = _extends({}, iconsCache);
    iconsCache = {};
  }

  return deletedItems;
};
var Icon = function Icon(_ref2) {
  var _classNames;

  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? '' : _ref2$color,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? '' : _ref2$size,
      _ref2$icon = _ref2.icon,
      icon = _ref2$icon === void 0 ? '' : _ref2$icon,
      className = _ref2.className,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? false : _ref2$padding,
      onIconLoad = _ref2.onIconLoad,
      _ref2$noCache = _ref2.noCache,
      noCache = _ref2$noCache === void 0 ? false : _ref2$noCache,
      attributes = _objectWithoutPropertiesLoose(_ref2, ["color", "size", "icon", "className", "padding", "onIconLoad", "noCache"]);

  var _useState = useState(iconsCache[icon]),
      IconComponent = _useState[0],
      setCurrentIcon = _useState[1];

  var classes = classNames('icon', className, (_classNames = {}, _classNames["icon-" + color] = color, _classNames["icon-" + size] = size, _classNames['icon-padded'] = padding, _classNames));
  useEffect(function () {
    if (isBundledIcon(icon) && (noCache || !iconsCache[icon])) {
      loadIcon(icon).then(function (_ref3) {
        var component = _ref3.component;

        iconsCache[icon] = function () {
          return component;
        };

        setCurrentIcon(iconsCache[icon]);
        onIconLoad == null ? void 0 : onIconLoad();
      });
    } else {
      onIconLoad == null ? void 0 : onIconLoad();
    }
  }, [icon, onIconLoad]);

  if (!isBundledIcon(icon)) {
    // assume it's an image and let the browser do its job
    return (// eslint-disable-next-line jsx-a11y/alt-text
      React__default.createElement("img", Object.assign({
        src: icon,
        className: classes
      }, attributes))
    );
  }

  if (!IconComponent) {
    return React__default.createElement(EmptyIcon, Object.assign({
      className: classes,
      role: 'img'
    }, attributes));
  }

  return React__default.createElement(IconComponent, Object.assign({
    className: classes,
    role: 'img'
  }, attributes));
};

var CardCategory = function CardCategory(_ref) {
  var iconName = _ref.iconName,
      date = _ref.date,
      href = _ref.href,
      onClick = _ref.onClick,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["iconName", "date", "href", "onClick", "children"]);

  var classes = classNames({
    'category-top': date || ' ',
    'categoryicon-top': iconName
  }); // Simple category link

  var categoryLink = !iconName && React__default.createElement("a", {
    href: href,
    className: 'category',
    onClick: onClick
  }, children);
  var categoryDate = date && React__default.createElement("span", {
    className: 'data'
  }, date); // Category with icon

  var categoryText = iconName && React__default.createElement("span", {
    className: 'text'
  }, children);
  var categoryIcon = iconName && React__default.createElement(Icon, {
    icon: iconName
  });
  return React__default.createElement("div", Object.assign({
    className: classes
  }, rest), categoryLink, categoryIcon, categoryText, categoryDate);
};

var CardTag = function CardTag(_ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'a' : _ref$tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag"]);

  var Tag = tag;
  var classes = classNames(className, 'card-tag');
  return React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes));
};

var CardTagsHeader = function CardTagsHeader(_ref) {
  var date = _ref.date,
      children = _ref.children,
      className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["date", "children", "className", "tag"]);

  var Tag = tag;
  var classes = classNames('head-tags', className);
  return React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes), children, date && React__default.createElement("span", {
    className: 'data'
  }, date));
};

var CardSignature = function CardSignature(_ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'span' : _ref$tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag"]);

  var Tag = tag;
  var classes = classNames(className, 'card-signature');
  return React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes));
};

var CardFooterCTA = function CardFooterCTA(_ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag"]);

  var Tag = tag;
  var classes = classNames(className, 'it-card-footer');
  return React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes));
};

var CardReadMore = function CardReadMore(_ref) {
  var className = _ref.className,
      text = _ref.text,
      _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === void 0 ? 'it-arrow-right' : _ref$iconName,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'a' : _ref$tag,
      href = _ref.href,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "text", "iconName", "tag", "href"]);

  var Tag = tag;
  var classes = classNames(className, 'read-more');
  return React__default.createElement(Tag, Object.assign({
    className: classes,
    href: href
  }, attributes), React__default.createElement("span", {
    className: 'text'
  }, text), iconName && React__default.createElement(Icon, {
    icon: iconName
  }));
};

var Collapse = function Collapse(_ref) {
  var _ref$header = _ref.header,
      header = _ref$header === void 0 ? false : _ref$header,
      className = _ref.className,
      navbar = _ref.navbar,
      megamenu = _ref.megamenu,
      children = _ref.children,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      onOverlayClick = _ref.onOverlayClick,
      cssModule = _ref.cssModule,
      attributes = _objectWithoutPropertiesLoose(_ref, ["header", "className", "navbar", "megamenu", "children", "isOpen", "onOverlayClick", "cssModule"]);

  var newCssModule = _extends({
    'navbar-collapse': 'navbar-collapsable'
  }, cssModule);

  if (megamenu || navbar || header) {
    var _classes = classNames(className, 'navbar-collapse', {
      expanded: isOpen
    });

    var style = {
      display: isOpen ? 'block' : 'none'
    };
    return React__default.createElement(Collapse$1, Object.assign({
      className: _classes,
      cssModule: newCssModule,
      navbar: navbar,
      style: style
    }, attributes), React__default.createElement("div", {
      className: 'overlay',
      style: style,
      onClick: onOverlayClick
    }), React__default.createElement("div", {
      className: 'close-div sr-only'
    }, React__default.createElement("button", {
      className: 'btn close-menu',
      type: 'button'
    }, React__default.createElement("span", {
      className: 'visually-hidden'
    }, "close"), React__default.createElement(Icon, {
      icon: "it-close-big"
    }))), megamenu ? React__default.createElement("div", {
      className: 'menu-wrapper'
    }, children) : React__default.createElement(React__default.Fragment, null, children));
  }

  var classes = classNames(className, {
    'link-list-wrapper': header
  });
  return React__default.createElement(Collapse$1, Object.assign({
    className: classes,
    cssModule: newCssModule
  }, attributes, {
    navbar: navbar,
    isOpen: isOpen
  }), children);
};

var GridItem = function GridItem(_ref) {
  var _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "className", "children"]);

  var classes = classNames('it-grid-item-wrapper', className);
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: classes
  }), children);
};

var GridItemText = function GridItemText(_ref) {
  var className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "children"]);

  var classes = classNames('it-griditem-text', className);
  return React__default.createElement("span", Object.assign({}, attributes, {
    className: classes
  }), children);
};

var GridItemTextWrapper = function GridItemTextWrapper(_ref) {
  var className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "children"]);

  var classes = classNames('it-griditem-text-wrapper', className);
  return React__default.createElement("span", Object.assign({}, attributes, {
    className: classes
  }), children);
};

var GridList = function GridList(_ref) {
  var className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "children"]);

  var classes = classNames('it-grid-list-wrapper', className);
  return React__default.createElement("div", Object.assign({}, attributes, {
    className: classes
  }), children);
};

var GridRow = function GridRow(_ref) {
  var className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "children"]);

  var classes = classNames('grid-row', className);
  return React__default.createElement("div", Object.assign({}, attributes, {
    className: classes
  }), children);
};

var LinkList = function LinkList(_ref) {
  var className = _ref.className,
      wrapperClassName = _ref.wrapperClassName,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      multiline = _ref.multiline,
      header = _ref.header,
      sublist = _ref.sublist,
      avatar = _ref.avatar,
      noWrapper = _ref.noWrapper,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "wrapperClassName", "tag", "multiline", "header", "sublist", "avatar", "noWrapper"]);

  var Tag = tag;
  var wrapperClasses = classNames('link-list-wrapper', wrapperClassName, {
    multiline: multiline
  });
  var classes = classNames(className, {
    'link-list': !sublist,
    'link-sublist': sublist,
    'avatar-group': avatar
  });

  if (noWrapper) {
    return React__default.createElement("ul", Object.assign({}, attributes, {
      className: classes
    }));
  }

  if (sublist) {
    return React__default.createElement(React__default.Fragment, null, header, React__default.createElement("ul", Object.assign({}, attributes, {
      className: classes
    })));
  }

  return React__default.createElement(Tag, {
    className: wrapperClasses
  }, header, React__default.createElement("ul", Object.assign({}, attributes, {
    className: classes
  })));
};

var handleDisabledOnClick = function handleDisabledOnClick(e) {
  e.preventDefault();
};

var LinkListItem = function LinkListItem(_ref) {
  var className = _ref.className,
      active = _ref.active,
      disabled = _ref.disabled,
      header = _ref.header,
      divider = _ref.divider,
      href = _ref.href,
      size = _ref.size,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'a' : _ref$tag,
      wrapperClassName = _ref.wrapperClassName,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "active", "disabled", "header", "divider", "href", "size", "tag", "wrapperClassName", "children"]);

  var Tag = tag;
  var classes = classNames(className, {
    active: active,
    disabled: disabled,
    header: header,
    divider: divider,
    size: size
  }, 'list-item'); // Prevent click event when disabled.

  var handlers = {};

  if (disabled) {
    handlers.onClick = handleDisabledOnClick;
  }

  if (header) {
    Tag = 'h3';
  } else if (divider) {
    Tag = 'span';
  }

  if (header && href) {
    return React__default.createElement("li", {
      className: wrapperClassName
    }, React__default.createElement(Tag, null, React__default.createElement("a", Object.assign({
      href: href || '#'
    }, attributes, {
      className: classes
    }, handlers), children)));
  }

  return React__default.createElement("li", {
    className: wrapperClassName
  }, React__default.createElement(Tag, Object.assign({}, attributes, {
    className: classes,
    href: href
  }, handlers), children));
};

var Footer = function Footer(_ref) {
  var className = _ref.className,
      logoEnte = _ref.logoEnte,
      logoUE = _ref.logoUE,
      nomeEnte = _ref.nomeEnte,
      indirizzo = _ref.indirizzo,
      partitaIva = _ref.partitaIva,
      iban = _ref.iban,
      telefono = _ref.telefono,
      pec = _ref.pec,
      linkAccessibilita = _ref.linkAccessibilita,
      linkAppuntamenti = _ref.linkAppuntamenti,
      numeroVerde = _ref.numeroVerde,
      cellulare = _ref.cellulare,
      navigazioneReact = _ref.navigazioneReact,
      baseUrl = _ref.baseUrl,
      footerLinks = _ref.footerLinks,
      linkUrp = _ref.linkUrp,
      linkNoteLegali = _ref.linkNoteLegali,
      linkGdpr = _ref.linkGdpr,
      sezServizi = _ref.sezServizi,
      sezAContatti = _ref.sezAContatti,
      sezBContatti = _ref.sezBContatti,
      sezPoweredBy = _ref.sezPoweredBy,
      sezImmagine = _ref.sezImmagine,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "logoEnte", "logoUE", "logoDeda", "nomeEnte", "indirizzo", "partitaIva", "iban", "telefono", "pec", "linkAccessibilita", "linkAppuntamenti", "numeroVerde", "cellulare", "navigazioneReact", "baseUrl", "footerLinks", "linkUrp", "linkNoteLegali", "linkGdpr", "sezServizi", "sezAContatti", "sezBContatti", "sezPoweredBy", "sezImmagine"]);

  var classes = classNames(className, 'it-footer');
  return React__default.createElement("footer", Object.assign({
    className: classes + " it-footer"
  }, attributes), React__default.createElement("div", {
    className: "it-footer-main"
  }, React__default.createElement(Container, null, React__default.createElement("section", null, React__default.createElement(Row, {
    className: 'py-4'
  }, sezImmagine && React__default.createElement(Col, {
    xs: 12,
    md: 3
  }, React__default.createElement("img", {
    src: baseUrl + logoUE,
    alt: 'logo Unione Europea',
    className: 'it-brand-wrapper',
    style: {
      height: '56px',
      width: '178px'
    }
  })), React__default.createElement(Col, {
    lg: 4,
    className: 'it-brand-wrapper'
  }, React__default.createElement("div", null, React__default.createElement("a", {
    href: "#"
  }, React__default.createElement(Icon, {
    icon: baseUrl + logoEnte,
    // @ts-ignore
    alt: 'logo ente'
  }), React__default.createElement("div", {
    className: "it-brand-text"
  }, React__default.createElement("h2", null, nomeEnte))))))), React__default.createElement("section", null, React__default.createElement(Row, null, sezServizi && React__default.createElement(Col, {
    className: "pb-2",
    xs: 12,
    sm: 12,
    md: 3
  }, React__default.createElement("a", null, React__default.createElement("h3", null, "Servizi")), React__default.createElement("hr", null), React__default.createElement("div", {
    className: "link-list-wrapper"
  }, React__default.createElement(LinkList, {
    className: "footer-list clearfix link-list"
  }, footerLinks == null ? void 0 : footerLinks.map(function (elem) {
    return React__default.createElement(React__default.Fragment, null, navigazioneReact ? React__default.createElement("li", null, React__default.createElement(Link, {
      className: 'list-item text-white',
      to: elem.link
    }, elem.label)) : React__default.createElement(LinkListItem, {
      href: baseUrl + elem.link,
      title: "Vai alla pagina: " + elem.label
    }, elem.label));
  })))), (sezAContatti || sezBContatti) && React__default.createElement(Col, {
    className: "pb-2",
    xs: 12,
    sm: 12,
    md: 9
  }, React__default.createElement("a", null, React__default.createElement("h3", null, "Contatti")), React__default.createElement("hr", null), React__default.createElement(Row, null, sezAContatti && React__default.createElement(Col, {
    className: "pb-2",
    xs: 12,
    sm: 6
  }, React__default.createElement("p", null, React__default.createElement("strong", null, nomeEnte), React__default.createElement("br", null), indirizzo, React__default.createElement("br", null), "Codice fiscale / P. IVA: ", partitaIva, React__default.createElement("br", null), "IBAN: ", iban, React__default.createElement("br", null), "Centralino unico: ", telefono)), sezBContatti && React__default.createElement(Col, {
    className: "pb-2",
    xs: 12,
    sm: 6
  }, React__default.createElement(LinkList, {
    className: "footer-list clearfix"
  }, React__default.createElement(LinkListItem, {
    href: linkUrp,
    title: "Vai alla pagina: URP - Ufficio Relazioni con il Pubblico"
  }, "URP - Ufficio Relazioni con il Pubblico"), React__default.createElement(LinkListItem, {
    href: linkAppuntamenti,
    title: 'Vai alla pagina di prenotazione appuntamento'
  }, "Prenotazione appuntamento"), React__default.createElement(LinkListItem, {
    href: "mailto:" + pec,
    title: pec
  }, "Posta Elettronica Certificata")), React__default.createElement("p", null, "Numero Verde: ", numeroVerde, React__default.createElement("br", null), "SMS e Whatsapp: ", cellulare)))))))), React__default.createElement("div", {
    className: "it-footer-small-prints clearfix"
  }, React__default.createElement(Container, null, React__default.createElement(Row, null, React__default.createElement(Col, {
    sm: '12',
    md: '12',
    lg: '6'
  }, React__default.createElement("ul", {
    className: "it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row"
  }, linkGdpr && React__default.createElement("li", {
    className: "list-inline-item"
  }, navigazioneReact ? React__default.createElement(Link, {
    to: "/portal/informativa_gdpr",
    title: "Informativa Privacy"
  }, "Informativa Privacy") : React__default.createElement("a", {
    href: baseUrl + "/portal/informativa_gdpr",
    title: "Informativa Privacy"
  }, "Informativa Privacy")), linkNoteLegali && React__default.createElement("li", {
    className: "list-inline-item"
  }, React__default.createElement("a", {
    href: linkNoteLegali,
    target: "_blank",
    title: "Note Legali"
  }, "Note legali")), linkAccessibilita && React__default.createElement("li", {
    className: "list-inline-item"
  }, React__default.createElement("a", {
    href: linkAccessibilita,
    target: "_blank",
    title: "Dichiarazione di Accessibilit\xE0"
  }, "Dichiarazione di accessibilit\xE0")))), sezPoweredBy && // <Col>
  //     <ul className="it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row-reverse">
  //         <li className="list-inline-item">
  //             <a className="d-none d-md-block" href="https://www.dedanext.it/" target='_blank'>
  //                 {`© ${(new Date).getFullYear()} ${nomeEnte} powered by Deda Next S.r.l.`}
  //             </a>
  //             <a className="d-md-none" href="https://www.dedanext.it/" target='_blank'>
  //                 {`© ${(new Date).getFullYear()}`}
  //                 <img
  //                     height="33px"
  //                     width="100px"
  //                     className="dedalogo"
  //                     src={logoDeda}
  //                     alt='logo deda next'
  //                 />
  //             </a>
  //         </li>
  //     </ul>
  // </Col>
  React__default.createElement(Col, {
    sm: '12',
    md: '12',
    lg: '6'
  }, parse(sezPoweredBy.replace("#NOME_ENTE#", nomeEnte)))))));
};

var SLIM = 'slim';
var CENTER = 'center';
var NAVBAR = 'navbar';
var HeaderContext = /*#__PURE__*/createContext({});
var useHeaderContext = function useHeaderContext() {
  var _useContext = useContext(HeaderContext),
      type = _useContext.type;

  return type;
};

var Header = function Header(_ref) {
  var _classNames;

  var className = _ref.className,
      _ref$small = _ref.small,
      small = _ref$small === void 0 ? false : _ref$small,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? '' : _ref$theme,
      type = _ref.type,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "small", "theme", "type"]);

  // use context here as theme
  var classes = classNames(className, (_classNames = {}, _classNames["it-header-" + type + "-wrapper"] = type, _classNames['it-small-header'] = type === CENTER && small, _classNames["theme-" + theme] = type !== NAVBAR && theme, _classNames['theme-dark-mobile'] = type === NAVBAR && theme === 'dark', _classNames['theme-light-desk'] = type === NAVBAR && theme === 'light', _classNames));
  return React__default.createElement(HeaderContext.Provider, {
    value: {
      type: type
    }
  }, React__default.createElement("div", Object.assign({
    className: classes
  }, attributes)));
};

var HeaderBrand = function HeaderBrand(_ref) {
  var className = _ref.className,
      href = _ref.href,
      iconName = _ref.iconName,
      children = _ref.children,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'a' : _ref$tag,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? false : _ref$responsive,
      altIcon = _ref.altIcon,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "href", "iconName", "children", "tag", "responsive", "altIcon"]);

  var type = useHeaderContext();
  var defaultAttributes = {
    tag: tag
  };

  if (type !== CENTER) {
    var classes = classNames('d-lg-block', className, {
      'd-none': !responsive
    });
    return React__default.createElement(NavbarBrand, Object.assign({
      className: classes,
      href: href
    }, attributes, defaultAttributes), children);
  }

  return React__default.createElement("div", {
    className: 'it-brand-wrapper'
  }, React__default.createElement("a", {
    href: href
  }, // @ts-ignore: ignore
  iconName && React__default.createElement(Icon, {
    icon: iconName,
    alt: altIcon
  }), React__default.createElement("div", {
    className: 'it-brand-text'
  }, React__default.Children.map(children, function (child, i) {
    if (typeof child !== 'object' || child == null || !('props' in child)) {
      return child;
    } // convention here: first item is the main title, while others subtext


    var className = classNames(child.props.className, {
      'd-none d-md-block': i
    } // subtext is anything but first element
    );
    var props = {
      className: className
    };
    return React__default.cloneElement(child, props);
  }))));
};

var HeaderContent = function HeaderContent(_ref) {
  var className = _ref.className,
      megamenu = _ref.megamenu,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "megamenu"]);

  var type = useHeaderContext();
  var classes = classNames(className, {
    'it-header-slim-wrapper-content': type === SLIM,
    'it-header-center-content-wrapper': type === CENTER,
    navbar: type === NAVBAR,
    'has-megamenu': megamenu
  });
  var Content = type === NAVBAR ? React__default.createElement(Navbar, Object.assign({
    className: classes
  }, attributes)) : React__default.createElement("div", Object.assign({
    className: classes
  }, attributes));
  return React__default.createElement(Container, null, React__default.createElement(Row, null, React__default.createElement(Col, null, Content)));
};

var HeaderRightZone = function HeaderRightZone(_ref) {
  var className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className"]);

  var type = useHeaderContext();
  var classes = classNames(className, {
    // BI >= 1.3.6
    'it-header-slim-right-zone': type === SLIM,
    // BI < 1.3.6
    'header-slim-right-zone': type === SLIM,
    'it-right-zone': type !== SLIM
  });
  return React__default.createElement("div", Object.assign({
    className: classes
  }, attributes));
};

var Headers = function Headers(_ref) {
  var className = _ref.className,
      _ref$shadow = _ref.shadow,
      shadow = _ref$shadow === void 0 ? false : _ref$shadow,
      _ref$sticky = _ref.sticky,
      sticky = _ref$sticky === void 0 ? false : _ref$sticky,
      _ref$classNameSticky = _ref.classNameSticky,
      classNameSticky = _ref$classNameSticky === void 0 ? '' : _ref$classNameSticky,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "shadow", "sticky", "classNameSticky"]);

  var classes = classNames('it-header-wrapper', {
    'it-shadow': shadow,
    'it-header-sticky': sticky
  }, className);
  var classTest = classNames(classNameSticky);

  if (!sticky) {
    return React__default.createElement("div", Object.assign({
      className: classes
    }, attributes));
  }

  return React__default.createElement(StickyProvider, null, React__default.createElement(Sticky, {
    style: {
      position: 'sticky',
      zIndex: 2
    },
    stickyProps: {
      className: classTest
    }
  }, React__default.createElement("div", Object.assign({
    className: classes
  }, attributes))));
};

var BUTTON = 'button';
var HeaderToggler = function HeaderToggler(_ref) {
  var className = _ref.className,
      tag = _ref.tag,
      type = _ref.type,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag", "type"]);

  var HeaderType = useHeaderContext();
  var defaultTag = HeaderType === SLIM ? 'a' : BUTTON;
  var defaultType = HeaderType === SLIM ? undefined : BUTTON;
  var classes = classNames({
    'it-opener d-lg-none': HeaderType === SLIM,
    'custom-navbar-toggler': HeaderType === NAVBAR
  }, className);
  return React__default.createElement(NavbarToggler, Object.assign({
    className: classes
  }, attributes, {
    tag: tag || defaultTag,
    type: type || defaultType,
    href: '#'
  }));
};

var Nav = function Nav(_ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'ul' : _ref$tag,
      _ref$vertical = _ref.vertical,
      vertical = _ref$vertical === void 0 ? false : _ref$vertical,
      secondary = _ref.secondary,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag", "vertical", "secondary"]);

  var classes = classNames(className, {
    'navbar-secondary': secondary
  });
  return React__default.createElement(Nav$1, Object.assign({
    className: classes,
    tag: tag,
    vertical: vertical
  }, attributes));
};

var LoginButton = /*#__PURE__*/function (_Component) {
  _inheritsLoose(LoginButton, _Component);

  //costruttore
  function LoginButton(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isDropDownOpen: false
    };
    return _this;
  }

  var _proto = LoginButton.prototype;

  _proto.render = function render() {
    var _this$props$className,
        _this2 = this;

    return this.props.userLogged && this.props.user != null ? React__default.createElement(Dropdown, {
      className: ((_this$props$className = this.props.className) != null ? _this$props$className : '') + " btn btn-full btn-icon",
      isOpen: this.state.isDropDownOpen,
      toggle: function toggle() {
        return _this2.setState({
          isDropDownOpen: !_this2.state.isDropDownOpen
        });
      }
    }, React__default.createElement(DropdownToggle, {
      color: "" + (this.props.compressed ? '' : 'primary'),
      caret: true,
      nav: !this.props.compressed
    }, React__default.createElement("span", {
      className: "rounded-icon"
    }, React__default.createElement(AvatarContainer, null, React__default.createElement(AvatarIcon, {
      color: 'secondary',
      size: 'sm'
    }, React__default.createElement("p", {
      "aria-hidden": 'true'
    }, "" + (this.props.user.nome != null ? this.props.user.nome.charAt(0).toLocaleUpperCase() : '') + ("" + (this.props.user.cognome != null ? this.props.user.cognome.charAt(0).toLocaleUpperCase() : ''))), React__default.createElement("span", {
      className: 'visually-hidden'
    }, React__default.createElement("strong", null, this.props.user.nome + " " + this.props.user.cognome))))), React__default.createElement("span", {
      className: "d-none d-lg-block"
    }, this.props.user.nome.toUpperCase() + " " + this.props.user.cognome.toUpperCase())), React__default.createElement(DropdownMenu, {
      className: "" + (this.props.compressed ? 'mt-md-5' : 'mt-md-3')
    }, React__default.createElement(LinkList, null, React__default.createElement("li", null, this.props.navigazioneReact ? React__default.createElement(Link, {
      className: 'list-item',
      to: '/portal'
    }, React__default.createElement("span", null, "Area personale")) : React__default.createElement("a", {
      className: 'list-item',
      href: this.props.baseUrl + '/portal'
    }, React__default.createElement("span", null, "Area personale"))), React__default.createElement("li", null, this.props.navigazioneReact ? React__default.createElement(Link, {
      className: 'list-item',
      to: '/portal/dettagli_utente'
    }, React__default.createElement("span", null, "Profilo")) : React__default.createElement("a", {
      className: 'list-item',
      href: this.props.baseUrl + '/portal/dettagli_utente'
    }, React__default.createElement("span", null, "Profilo"))), React__default.createElement("li", null, this.props.navigazioneReact ? React__default.createElement(Link, {
      className: 'list-item',
      to: '/portal/servizi'
    }, React__default.createElement("span", null, "Gestisci Servizi")) : React__default.createElement("a", {
      className: 'list-item',
      href: this.props.baseUrl + '/portal/servizi'
    }, React__default.createElement("span", null, "Gestisci Servizi"))), React__default.createElement(LinkListItem, {
      className: 'list-item',
      href: this.props.logOutUrl ? this.props.logOutUrl : this.props.baseUrl + '/portal/autenticazione/logout',
      "data-no-turbolink": this.props.turboLinksDisabled ? "true" : "false",
      "data-turbolinks": this.props.turboLinksDisabled ? "false" : "true"
    }, React__default.createElement("span", null, "Logout"))))) : React__default.createElement(React__default.Fragment, null, this.props.navigazioneReact ? React__default.createElement(Link, {
      className: "btn btn-icon btn-full",
      to: '/portal/autenticazione',
      "aria-label": "Accedi all'area personale"
    }, React__default.createElement("span", {
      className: "rounded-icon"
    }, React__default.createElement(Icon, {
      color: "primary",
      icon: "it-user"
    })), React__default.createElement("span", {
      className: "d-none d-lg-block text-white"
    }, "Accedi all'area personale")) : React__default.createElement("a", {
      className: "btn btn-icon btn-full",
      href: this.props.baseUrl + '/portal/autenticazione',
      "aria-label": "Accedi all'area personale"
    }, React__default.createElement("span", {
      className: "rounded-icon"
    }, React__default.createElement(Icon, {
      color: "primary",
      icon: "it-user"
    })), React__default.createElement("span", {
      className: "d-none d-lg-block text-white"
    }, "Accedi all'area personale")));
  };

  return LoginButton;
}(Component);
var FullHeader = /*#__PURE__*/function (_Component2) {
  _inheritsLoose(FullHeader, _Component2);

  function FullHeader(props) {
    var _this3;

    _this3 = _Component2.call(this, props) || this;
    _this3.state = {
      isStickyClass: false,
      isNavbarOpen: false
    };
    _this3.onScroll = _this3.onScroll.bind(_assertThisInitialized(_this3));
    _this3.onButtonClick = _this3.onButtonClick.bind(_assertThisInitialized(_this3));
    return _this3;
  }
  /* --------- Handlers  --------- */


  var _proto2 = FullHeader.prototype;

  _proto2.onScroll = function onScroll() {
    if (this.props.sticky && window.scrollY > 100) {
      this.setState({
        isStickyClass: true
      });
    } else if (this.props.sticky && window.scrollY < 30) {
      this.setState({
        isStickyClass: false
      });
    }
  };

  _proto2.onButtonClick = function onButtonClick() {
    this.setState({
      isNavbarOpen: false
    });
  }
  /* --------- Lifecycle functions --------- */
  ;

  _proto2.componentDidMount = function componentDidMount() {
    var _document$querySelect;

    // Necessario per effettuare lo scroll della pagina
    window.addEventListener('scroll', this.onScroll); // Chiusura tramite icona X del burger menù

    (_document$querySelect = document.querySelector('.btn.close-menu')) == null ? void 0 : _document$querySelect.addEventListener('click', this.onButtonClick);
  };

  _proto2.componentWillUnmount = function componentWillUnmount() {
    var _document$querySelect2;

    // Rimozioni a fine life-cycle
    window.removeEventListener('scroll', this.onScroll);
    (_document$querySelect2 = document.querySelector('.btn.close-menu')) == null ? void 0 : _document$querySelect2.removeEventListener('click', this.onButtonClick);
  };

  _proto2.render = function render() {
    var _this$props$user,
        _this4 = this,
        _this$props$officialW,
        _this$props$headerLin,
        _this$props$user2,
        _this$props$headerLin2,
        _this$props$headerLin3;

    return React__default.createElement(React__default.Fragment, null, React__default.createElement("header", {
      style: this.props.sticky ? {
        position: 'sticky',
        zIndex: 10
      } : undefined
    }, React__default.createElement(Headers, {
      sticky: this.props.sticky,
      className: "" + (this.state.isStickyClass ? 'is-sticky' : ''),
      classNameSticky: this.props.classNameSticky
    }, React__default.createElement(Header, {
      type: 'slim'
    }, React__default.createElement(HeaderContent, null, React__default.createElement(HeaderBrand, {
      hidden: false,
      href: this.props.regione_sito,
      altIcon: 'logo ente'
    }, this.props.regione), React__default.createElement(HeaderToggler, null, React__default.createElement("a", {
      href: this.props.regione_sito
    }, this.props.regione)), React__default.createElement(HeaderRightZone, null, React__default.createElement(LoginButton, {
      user: (_this$props$user = this.props.user) != null ? _this$props$user : undefined,
      userLogged: this.props.userLogged,
      navigazioneReact: this.props.navigazioneReact,
      baseUrl: this.props.baseUrl,
      logOutUrl: this.props.logOutUrl,
      turboLinksDisabled: this.props.turboLinksDisabled
    })))), React__default.createElement("div", {
      className: 'it-nav-wrapper'
    }, React__default.createElement(Header, {
      type: 'center'
    }, React__default.createElement(HeaderContent, null, this.props.officialWebsite == null ? React__default.createElement(React__default.Fragment, null, this.props.navigazioneReact ? React__default.createElement(Link, {
      className: 'text-decoration-none',
      to: "/portal"
    }, React__default.createElement(HeaderBrand, {
      tag: "span",
      iconName: this.props.stemma ? this.props.baseUrl + this.props.stemma : 'it-pa',
      altIcon: 'logo ente'
    }, React__default.createElement("h1", {
      className: 'h2'
    }, this.props.nomeEnte), React__default.createElement("h2", {
      className: 'h3'
    }, "Servizi digitali per cittadini e imprese"))) : React__default.createElement("a", {
      className: 'text-decoration-none',
      href: this.props.baseUrl + "/portal"
    }, React__default.createElement(HeaderBrand, {
      tag: "span",
      iconName: this.props.stemma ? this.props.baseUrl + this.props.stemma : 'it-pa',
      altIcon: 'logo ente'
    }, React__default.createElement("h1", {
      className: 'h2'
    }, this.props.nomeEnte), React__default.createElement("h2", {
      className: 'h3'
    }, "Servizi digitali per cittadini e imprese")))) : React__default.createElement("a", {
      className: 'text-decoration-none',
      href: this.props.officialWebsite
    }, React__default.createElement(HeaderBrand, {
      tag: "span",
      iconName: this.props.stemma ? this.props.baseUrl + this.props.stemma : 'it-pa',
      altIcon: 'logo ente'
    }, React__default.createElement("h1", {
      className: 'h2'
    }, this.props.nomeEnte), React__default.createElement("h2", {
      className: 'h3'
    }, "Servizi digitali per cittadini e imprese"))), React__default.createElement(HeaderRightZone, null))), React__default.createElement(Header, {
      theme: "",
      type: "navbar"
    }, React__default.createElement(HeaderContent, {
      expand: 'lg',
      megamenu: true
    }, React__default.createElement(HeaderToggler, {
      "aria-controls": "nav1",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }, React__default.createElement(Icon, {
      icon: "it-burger",
      onClick: function onClick() {
        return _this4.setState({
          isNavbarOpen: true
        });
      }
    })), React__default.createElement(Collapse, {
      header: true,
      navbar: true,
      isOpen: this.state.isNavbarOpen,
      onOverlayClick: function onOverlayClick() {
        return _this4.setState({
          isNavbarOpen: false
        });
      }
    }, React__default.createElement("div", {
      className: "menu-wrapper"
    }, React__default.createElement("a", {
      href: "#",
      "aria-label": "Home " + this.props.nomeEnte,
      className: this.state.isNavbarOpen ? 'logo-hamburger' : 'd-none'
    }, React__default.createElement(Icon, {
      icon: this.props.stemmaBurger ? this.props.baseUrl + this.props.stemmaBurger : 'it-pa',
      // @ts-ignore: ignore
      alt: 'logo ente'
    }), React__default.createElement("div", {
      className: "it-brand-text"
    }, React__default.createElement("div", {
      className: "it-brand-title"
    }, this.props.nomeEnte))), React__default.createElement(Nav, {
      navbar: true,
      className: 'd-none d-lg-flex'
    }, React__default.createElement(NavItem, {
      className: "" + (this.state.isNavbarOpen || this.state.isStickyClass ? '' : 'd-none')
    }, this.props.officialWebsite || !this.props.navigazioneReact ? React__default.createElement("a", {
      href: (_this$props$officialW = this.props.officialWebsite) != null ? _this$props$officialW : this.props.baseUrl + '/portal',
      className: 'nav-link',
      style: {
        border: 'none'
      }
    }, React__default.createElement("img", {
      src: this.props.stemma ? this.props.baseUrl + this.props.stemma : 'it-pa',
      style: {
        width: '50px'
      },
      alt: 'logo ente'
    })) : React__default.createElement(NavLink, {
      to: '/portal',
      className: 'nav-link',
      style: {
        border: 'none'
      }
    }, React__default.createElement("img", {
      src: this.props.stemma ? this.props.baseUrl + this.props.stemma : 'it-pa',
      style: {
        width: '50px'
      },
      alt: 'logo ente'
    }))), (_this$props$headerLin = this.props.headerLinks) == null ? void 0 : _this$props$headerLin.map(function (elem) {
      return React__default.createElement(NavItem, null, _this4.props.navigazioneReact ? React__default.createElement(NavLink, {
        className: 'nav-link',
        to: elem.link
      }, elem.element ? elem.element : elem.label) : React__default.createElement("a", {
        className: 'nav-link',
        href: _this4.props.baseUrl + elem.link
      }, elem.element ? elem.element : elem.label));
    })), this.state.isStickyClass && this.props.stickyLogin && !this.state.isNavbarOpen && React__default.createElement("div", {
      className: 'it-user-wrapper nav-item dropdown'
    }, React__default.createElement(LoginButton, {
      user: (_this$props$user2 = this.props.user) != null ? _this$props$user2 : undefined,
      userLogged: this.props.userLogged,
      compressed: true,
      navigazioneReact: this.props.navigazioneReact,
      baseUrl: this.props.baseUrl
    })), React__default.createElement(Nav, {
      navbar: true,
      className: 'd-lg-none'
    }, !this.props.userLogged && React__default.createElement("li", {
      className: 'nav-item'
    }, this.props.navigazioneReact ? React__default.createElement(Link, {
      className: 'nav-link',
      to: '/portal/autenticazione',
      onClick: function onClick() {
        return _this4.setState({
          isNavbarOpen: false
        });
      }
    }, "Accedi") : React__default.createElement("a", {
      className: 'nav-link',
      href: this.props.baseUrl + '/portal/autenticazione',
      onClick: function onClick() {
        return _this4.setState({
          isNavbarOpen: false
        });
      }
    }, "Accedi")), this.props.user != null && this.props.user.nome != null && this.props.user.nome !== '' && React__default.createElement(NavItem, null, React__default.createElement(UncontrolledDropdown, {
      nav: true,
      tag: 'div',
      inNavbar: true
    }, React__default.createElement(DropdownToggle, {
      caret: true,
      nav: true
    }, this.props.user.nome.toUpperCase() + " " + this.props.user.cognome.toUpperCase(), React__default.createElement(Icon, {
      icon: "it-expand"
    })), React__default.createElement(DropdownMenu, null, React__default.createElement(LinkList, null, React__default.createElement("li", {
      onClick: function onClick() {
        return _this4.setState({
          isNavbarOpen: false
        });
      }
    }, this.props.navigazioneReact ? React__default.createElement(Link, {
      className: 'list-item',
      to: '/portal'
    }, React__default.createElement("span", null, "Area personale")) : React__default.createElement("a", {
      className: 'list-item',
      href: this.props.baseUrl + '/portal'
    }, React__default.createElement("span", null, "Area personale"))), React__default.createElement("li", {
      onClick: function onClick() {
        return _this4.setState({
          isNavbarOpen: false
        });
      }
    }, this.props.navigazioneReact ? React__default.createElement(Link, {
      className: 'list-item',
      to: '/portal/dettagli_utente'
    }, React__default.createElement("span", null, "Profilo")) : React__default.createElement("a", {
      className: 'list-item',
      href: this.props.baseUrl + '/portal/dettagli_utente'
    }, React__default.createElement("span", null, "Profilo"))), React__default.createElement("li", {
      onClick: function onClick() {
        return _this4.setState({
          isNavbarOpen: false
        });
      }
    }, this.props.navigazioneReact ? React__default.createElement(Link, {
      className: 'list-item',
      to: '/portal/servizi'
    }, React__default.createElement("span", null, "Gestisci Servizi")) : React__default.createElement("a", {
      className: 'list-item',
      href: this.props.baseUrl + '/portal/servizi'
    }, React__default.createElement("span", null, "Gestisci Servizi"))), React__default.createElement(LinkListItem, {
      href: this.props.logOutUrl ? this.props.logOutUrl : this.props.baseUrl + '/portal/autenticazione/logout',
      "data-no-turbolinks": this.props.turboLinksDisabled ? "true" : "false",
      "data-turbolinks": this.props.turboLinksDisabled ? "false" : "true"
    }, React__default.createElement("span", null, "Logout")))))), this.props.navigazioneReact ? (_this$props$headerLin2 = this.props.headerLinks) == null ? void 0 : _this$props$headerLin2.map(function (elem) {
      return React__default.createElement(NavItem, null, React__default.createElement(Link, {
        className: 'nav-link',
        to: elem.link,
        onClick: function onClick() {
          return _this4.setState({
            isNavbarOpen: false
          });
        }
      }, elem.element ? elem.element : elem.label));
    }) : (_this$props$headerLin3 = this.props.headerLinks) == null ? void 0 : _this$props$headerLin3.map(function (elem) {
      return React__default.createElement(NavItem, null, React__default.createElement("a", {
        className: 'nav-link',
        href: "" + _this4.props.baseUrl + elem.link,
        onClick: function onClick() {
          return _this4.setState({
            isNavbarOpen: false
          });
        }
      }, elem.element ? elem.element : elem.label));
    })))))))), React__default.createElement("div", {
      style: {
        height: '120px',
        pointerEvents: 'none'
      },
      className: "" + (this.state.isStickyClass ? '' : 'd-none')
    })));
  };

  return FullHeader;
}(Component);

var HeaderLinkZone = function HeaderLinkZone(_ref) {
  var className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className"]);

  var classes = classNames(className);
  return React__default.createElement("div", {
    className: 'nav-mobile'
  }, React__default.createElement("nav", Object.assign({
    className: classes
  }, attributes)));
};

var HeaderSearch = function HeaderSearch(_ref) {
  var className = _ref.className,
      label = _ref.label,
      href = _ref.href,
      _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === void 0 ? 'it-search' : _ref$iconName,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "label", "href", "iconName"]);

  var classes = classNames('it-search-wrapper', className);
  return React__default.createElement("div", Object.assign({
    className: classes
  }, attributes), label && React__default.createElement("span", {
    className: 'd-none d-md-block'
  }, label), React__default.createElement("a", {
    className: 'search-link rounded-icon',
    "aria-label": label,
    href: href
  }, React__default.createElement(Icon, {
    icon: iconName
  })));
};

var HeaderSocialsZone = function HeaderSocialsZone(_ref) {
  var className = _ref.className,
      children = _ref.children,
      label = _ref.label,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "children", "label"]);

  var classes = classNames('it-socials d-none d-md-flex', className);
  return React__default.createElement("div", Object.assign({
    className: classes
  }, attributes), label && React__default.createElement("span", null, label), children);
};

var Hero = function Hero(_ref) {
  var _classname;

  var _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      small = _ref.small,
      centered = _ref.centered,
      overlay = _ref.overlay,
      overlap = _ref.overlap,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "small", "centered", "overlay", "overlap", "className"]);

  var classes = classNames('it-hero-wrapper', className, (_classname = {
    'it-overlay': overlay
  }, _classname['it-' + overlay] = overlay, _classname['it-hero-small-size'] = small, _classname['it-text-centered'] = centered, _classname['it-bottom-overlapping-content'] = overlap, _classname));
  return React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes));
};

var HeroBackground = function HeroBackground(_ref) {
  var alt = _ref.alt,
      attributes = _objectWithoutPropertiesLoose(_ref, ["alt"]);

  return React__default.createElement("div", {
    className: 'img-responsive-wrapper'
  }, React__default.createElement("div", {
    className: 'img-responsive'
  }, React__default.createElement("div", {
    className: 'img-wrapper'
  }, React__default.createElement("img", Object.assign({}, attributes, {
    alt: alt
  })))));
};

var HeroBody = function HeroBody(_ref) {
  var children = _ref.children,
      className = _ref.className;
  var classes = classNames('it-hero-text-wrapper', 'bg-dark', className);
  return React__default.createElement(Container, null, React__default.createElement(Row, null, React__default.createElement(Col, null, React__default.createElement("div", {
    className: classes
  }, children))));
};

var HeroButton = function HeroButton(_ref) {
  var wrapperClassName = _ref.wrapperClassName,
      attributes = _objectWithoutPropertiesLoose(_ref, ["wrapperClassName"]);

  var classes = classNames('it-btn-container', wrapperClassName);
  return React__default.createElement("div", {
    className: classes
  }, React__default.createElement(Button, Object.assign({
    size: 'sm'
  }, attributes)));
};

var HeroCategory = function HeroCategory(_ref) {
  var className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className"]);

  var classes = classNames('it-category', className);
  return React__default.createElement("span", Object.assign({}, attributes, {
    className: classes
  }));
};

var HeroTitle = function HeroTitle(_ref) {
  var _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'h1' : _ref$tag,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "className"]);

  var classes = classNames(className);
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: classes
  }));
};

var InputContainer = function InputContainer(_ref) {
  var id = _ref.id,
      infoId = _ref.infoId,
      activeClass = _ref.activeClass,
      label = _ref.label,
      infoTextClass = _ref.infoTextClass,
      infoText = _ref.infoText,
      wrapperClass = _ref.wrapperClass,
      children = _ref.children;
  return React__default.createElement("div", {
    className: wrapperClass
  }, children, React__default.createElement("label", {
    htmlFor: id,
    className: activeClass
  }, label), React__default.createElement("small", {
    id: infoId,
    className: infoTextClass
  }, infoText));
};

function getFormControlClassInternal(_ref) {
  var plaintext = _ref.plaintext,
      staticInput = _ref.staticInput,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      addon = _ref.addon,
      normalized = _ref.normalized;
  var formControlClass = 'form-control';

  if (plaintext || staticInput || normalized) {
    return formControlClass + "-plaintext";
  }

  if (type === 'file') {
    return formControlClass + "-file";
  }

  if (['radio', 'checkbox'].indexOf(type) > -1) {
    if (addon) {
      return null;
    }
  }

  return formControlClass;
}

function getFormControlClass(props, cssModule) {
  return mapToCssModules(getFormControlClassInternal(props), cssModule);
}
function getInfoTextControlClass(_ref2, cssModule) {
  var valid = _ref2.valid,
      invalid = _ref2.invalid;
  return mapToCssModules(classNames({
    'form-text': valid || invalid,
    'text-muted': !valid || invalid
  }), cssModule);
}
function getTag(_ref3) {
  var tag = _ref3.tag,
      plaintext = _ref3.plaintext,
      staticInput = _ref3.staticInput,
      _ref3$type = _ref3.type,
      type = _ref3$type === void 0 ? 'text' : _ref3$type;

  if (tag) {
    return tag;
  }

  if (['radio', 'checkbox'].indexOf(type) > -1) {
    return 'input';
  }

  if (plaintext || staticInput) {
    return 'p';
  }

  return 'input';
}
function getClasses(className, _ref4, cssModule) {
  var _classNames;

  var isFocused = _ref4.isFocused,
      valid = _ref4.valid,
      invalid = _ref4.invalid,
      bsSize = _ref4.bsSize,
      placeholder = _ref4.placeholder,
      value = _ref4.value,
      label = _ref4.label,
      infoText = _ref4.infoText,
      normalized = _ref4.normalized,
      inputPassword = _ref4.inputPassword,
      formControlClass = _ref4.formControlClass,
      infoTextControlClass = _ref4.infoTextControlClass,
      originalWrapperClass = _ref4.originalWrapperClass,
      helpCondition = _ref4.helpCondition;
  var hasPlainCondition = placeholder || label || infoText;
  var baseCondition = hasPlainCondition && !normalized && !inputPassword;
  var passwordOnlyCondition = inputPassword && !hasPlainCondition && !normalized;
  var normalizedOnlyCondition = normalized && !hasPlainCondition && !inputPassword;
  var classes = mapToCssModules(classNames(className, (_classNames = {
    'is-invalid': invalid,
    'is-valid': valid
  }, _classNames["form-control-" + bsSize] = bsSize, _classNames), formControlClass), cssModule);
  var wrapperClass = mapToCssModules(classNames(className, originalWrapperClass, 'form-group'), cssModule);
  var infoTextClass = mapToCssModules(classNames({
    'valid-feedback': valid,
    'invalid-feedback': invalid
  }, infoTextControlClass), cssModule);
  var inputClasses = mapToCssModules(classNames(classes, !baseCondition && {
    // we can model here only if stylings
    'form-control-plaintext': normalizedOnlyCondition,
    'form-control': passwordOnlyCondition,
    'input-password': passwordOnlyCondition,
    'focus--mouse': passwordOnlyCondition || normalizedOnlyCondition
  }), cssModule);
  var activeClass = mapToCssModules(classNames({
    active: isFocused || placeholder || value
  }, helpCondition && {
    'w-100': true,
    'd-flex': true,
    'justify-content-between': true
  }), cssModule);
  return {
    wrapperClass: wrapperClass,
    inputClasses: inputClasses,
    activeClass: activeClass,
    infoTextClass: infoTextClass
  };
}
function useFocus(_ref5) {
  var onFocus = _ref5.onFocus,
      onBlur = _ref5.onBlur;

  var _useState = useState(false),
      isFocused = _useState[0],
      setFocus = _useState[1];

  var toggleFocusLabel = useCallback(function (e) {
    setFocus(true);
    onFocus == null ? void 0 : onFocus(e);
  }, [onFocus]);
  var toggleBlurLabel = useCallback(function (e) {
    if (e.target.value === '') {
      setFocus(!isFocused);
    }

    onBlur == null ? void 0 : onBlur(e);
  }, [isFocused, onBlur]);
  return {
    toggleFocusLabel: toggleFocusLabel,
    toggleBlurLabel: toggleBlurLabel,
    isFocused: isFocused
  };
}

var Input = function Input(_ref) {
  var id = _ref.id,
      className = _ref.className,
      cssModule = _ref.cssModule,
      type = _ref.type,
      state = _ref.state,
      tag = _ref.tag,
      addon = _ref.addon,
      staticInput = _ref.static,
      plaintext = _ref.plaintext,
      innerRef = _ref.innerRef,
      label = _ref.label,
      infoText = _ref.infoText,
      placeholder = _ref.placeholder,
      normalized = _ref.normalized,
      value = _ref.value,
      originalWrapperClassOld = _ref.wrapperClass,
      originalWrapperClass = _ref.wrapperClassName,
      helpCondition = _ref.helpCondition,
      size = _ref.size,
      _ref$noWrapper = _ref.noWrapper,
      noWrapper = _ref$noWrapper === void 0 ? false : _ref$noWrapper,
      labelAlwaysActive = _ref.labelAlwaysActive,
      accept = _ref.accept,
      attributes = _objectWithoutPropertiesLoose(_ref, ["id", "className", "cssModule", "type", "state", "tag", "addon", "static", "plaintext", "innerRef", "label", "infoText", "placeholder", "normalized", "value", "wrapperClass", "wrapperClassName", "helpCondition", "size", "noWrapper", "labelAlwaysActive", "accept"]);

  var _useState = useState(true),
      isHidden = _useState[0],
      setHidden = _useState[1];

  var _useState2 = useState(true),
      hasIcon = _useState2[0],
      toggleIcon = _useState2[1];

  var _useFocus = useFocus({
    onFocus: attributes.onFocus,
    onBlur: attributes.onBlur
  }),
      toggleFocusLabel = _useFocus.toggleFocusLabel,
      toggleBlurLabel = _useFocus.toggleBlurLabel,
      isFocused = _useFocus.isFocused;

  var toggleShow = useCallback(function () {
    setHidden(!isHidden);
    toggleIcon(!hasIcon);
  }, [hasIcon, isHidden]);

  var bsSize = attributes.bsSize,
      valid = attributes.valid,
      invalid = attributes.invalid,
      rest = _objectWithoutPropertiesLoose(attributes, ["bsSize", "valid", "invalid"]);

  var Tag = getTag({
    tag: tag,
    plaintext: plaintext,
    staticInput: staticInput,
    type: type
  });
  var formControlClass = getFormControlClass({
    plaintext: plaintext,
    staticInput: staticInput,
    type: type,
    addon: addon,
    normalized: normalized
  }, cssModule);
  var infoTextControlClass = getInfoTextControlClass({
    valid: valid,
    invalid: invalid
  }, cssModule);

  if (state && valid == null && invalid == null) {
    invalid = state === 'danger';
    valid = state === 'success';
  }

  var extraAttributes = {};

  if (size && !isNumber(size)) {
    notifyDeprecation('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
    bsSize = size;
  } else {
    extraAttributes.size = size;
  }

  if (Tag === 'input' || typeof tag !== 'string') {
    extraAttributes.type = type;
  }

  if (type === 'file') {
    extraAttributes.accept = accept;
  } // associate the input field with the help text


  var infoId = id ? id + "Description" : undefined;

  if (id) {
    extraAttributes['aria-describedby'] = infoId;
  }

  if (attributes.children && !(plaintext || staticInput || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
    notifyDeprecation("Input with a type of \"" + type + "\" cannot have children. Please use \"value\"/\"defaultValue\" instead.");
    delete attributes.children;
  }

  var inputPassword = extraAttributes.type === 'password';
  var inputRadio = extraAttributes.type === 'radio'; // Styling

  var _getClasses = getClasses(className, {
    valid: valid,
    invalid: invalid,
    bsSize: bsSize,
    placeholder: placeholder,
    value: value,
    label: label,
    infoText: infoText,
    normalized: Boolean(normalized),
    inputPassword: inputPassword,
    formControlClass: formControlClass,
    infoTextControlClass: infoTextControlClass,
    isFocused: isFocused || (label != undefined && labelAlwaysActive != undefined ? labelAlwaysActive : false),
    originalWrapperClass: originalWrapperClass || originalWrapperClassOld,
    helpCondition: helpCondition
  }, cssModule),
      activeClass = _getClasses.activeClass,
      infoTextClass = _getClasses.infoTextClass,
      inputClasses = _getClasses.inputClasses,
      wrapperClass = _getClasses.wrapperClass; // set of attributes always shared by the Input components


  var sharedAttributes = {
    id: id,
    onFocus: toggleFocusLabel,
    onBlur: toggleBlurLabel,
    value: value,
    ref: innerRef
  }; // set of attributes always shared by the wrapper component

  var containerProps = {
    id: id,
    infoId: infoId,
    activeClass: activeClass,
    label: label,
    infoTextClass: infoTextClass,
    infoText: infoText,
    wrapperClass: wrapperClass
  };
  var inputAutoFillStyle = {
    WebkitAutofill: {
      color: 'red',
      backgroundColor: 'yellow'
    }
  };

  if (noWrapper) {
    return React__default.createElement(Tag, Object.assign({}, rest, extraAttributes, {
      className: inputClasses
    }, sharedAttributes, {
      placeholder: placeholder,
      style: inputAutoFillStyle
    }));
  }

  if (placeholder) {
    return React__default.createElement(InputContainer, Object.assign({}, containerProps), React__default.createElement(Tag, Object.assign({}, rest, extraAttributes, sharedAttributes, {
      className: inputClasses,
      placeholder: placeholder,
      style: inputAutoFillStyle
    })));
  }

  if (inputPassword) {
    return React__default.createElement(InputContainer, Object.assign({}, containerProps), React__default.createElement(Tag, Object.assign({}, rest, extraAttributes, sharedAttributes, {
      type: isHidden ? 'password' : 'text',
      className: inputClasses,
      placeholder: placeholder,
      style: inputAutoFillStyle
    })), React__default.createElement("span", {
      className: 'password-icon',
      "aria-hidden": 'true'
    }, React__default.createElement(Icon, {
      size: 'sm',
      icon: "it-password-" + (hasIcon ? 'visible' : 'invisible'),
      className: 'password-icon-visible',
      onClick: toggleShow,
      noCache: true
    })));
  }

  if (inputRadio) {
    return React__default.createElement(Tag, Object.assign({}, rest, extraAttributes, {
      className: inputClasses
    }, sharedAttributes, {
      style: _extends({}, inputAutoFillStyle, {
        cursor: 'pointer'
      })
    }));
  }

  if (normalized) {
    return React__default.createElement(InputContainer, Object.assign({}, containerProps), React__default.createElement(Tag, Object.assign({}, rest, extraAttributes, sharedAttributes, {
      className: inputClasses,
      readOnly: true,
      style: inputAutoFillStyle
    })));
  }

  if (label || infoText) {
    return React__default.createElement(InputContainer, Object.assign({}, containerProps), React__default.createElement(Tag, Object.assign({}, rest, extraAttributes, sharedAttributes, {
      className: inputClasses,
      style: inputAutoFillStyle
    })));
  }

  return React__default.createElement(Tag, Object.assign({}, rest, extraAttributes, {
    className: inputClasses
  }, sharedAttributes, {
    style: inputAutoFillStyle
  }));
};

var TextArea = function TextArea(_ref) {
  var id = _ref.id,
      className = _ref.className,
      cssModule = _ref.cssModule,
      innerRef = _ref.innerRef,
      label = _ref.label,
      infoText = _ref.infoText,
      placeholder = _ref.placeholder,
      normalized = _ref.normalized,
      value = _ref.value,
      originalWrapperClass = _ref.wrapperClassName,
      helpCondition = _ref.helpCondition,
      valid = _ref.valid,
      invalid = _ref.invalid,
      labelAlwaysActive = _ref.labelAlwaysActive,
      attributes = _objectWithoutPropertiesLoose(_ref, ["id", "className", "cssModule", "innerRef", "label", "infoText", "placeholder", "normalized", "value", "wrapperClassName", "helpCondition", "valid", "invalid", "labelAlwaysActive"]);

  var _useFocus = useFocus({
    onFocus: attributes.onFocus,
    onBlur: attributes.onBlur
  }),
      toggleFocusLabel = _useFocus.toggleFocusLabel,
      toggleBlurLabel = _useFocus.toggleBlurLabel,
      isFocused = _useFocus.isFocused;

  var infoTextControlClass = getInfoTextControlClass({
    valid: valid,
    invalid: invalid
  }, cssModule);
  var extraAttributes = {}; // associate the input field with the help text

  var infoId = id ? id + "Description" : undefined;

  if (id) {
    extraAttributes['aria-describedby'] = infoId;
  } // Styling


  var _getClasses = getClasses(className, {
    valid: valid,
    invalid: invalid,
    placeholder: placeholder,
    value: value,
    label: label,
    infoText: infoText,
    normalized: Boolean(normalized),
    infoTextControlClass: infoTextControlClass,
    isFocused: isFocused || (label != undefined && labelAlwaysActive != undefined ? labelAlwaysActive : false),
    originalWrapperClass: originalWrapperClass,
    helpCondition: helpCondition
  }, cssModule),
      activeClass = _getClasses.activeClass,
      infoTextClass = _getClasses.infoTextClass,
      inputClasses = _getClasses.inputClasses,
      wrapperClass = _getClasses.wrapperClass; // set of attributes always shared by the Input components


  var sharedAttributes = {
    id: id,
    onFocus: toggleFocusLabel,
    onBlur: toggleBlurLabel,
    value: value,
    ref: innerRef
  }; // set of attributes always shared by the wrapper component

  var containerProps = {
    id: id,
    infoId: infoId,
    activeClass: activeClass,
    label: label,
    infoTextClass: infoTextClass,
    infoText: infoText,
    wrapperClass: wrapperClass
  };

  if (placeholder) {
    return React__default.createElement(InputContainer, Object.assign({}, containerProps), React__default.createElement("textarea", Object.assign({}, attributes, extraAttributes, sharedAttributes, {
      className: inputClasses,
      placeholder: placeholder
    })));
  }

  if (normalized) {
    return React__default.createElement(InputContainer, Object.assign({}, containerProps), React__default.createElement("textarea", Object.assign({}, attributes, extraAttributes, sharedAttributes, {
      className: inputClasses,
      readOnly: true
    })));
  }

  if (label || infoText) {
    return React__default.createElement(InputContainer, Object.assign({}, containerProps), React__default.createElement("textarea", Object.assign({}, attributes, extraAttributes, sharedAttributes, {
      className: inputClasses
    })));
  }

  return React__default.createElement("textarea", Object.assign({}, attributes, extraAttributes, {
    className: inputClasses
  }, sharedAttributes, {
    ref: innerRef
  }));
};

var Spinner = function Spinner(_ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'span' : _ref$tag,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$small = _ref.small,
      small = _ref$small === void 0 ? false : _ref$small,
      _ref$double = _ref.double,
      double = _ref$double === void 0 ? false : _ref$double,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Caricamento' : _ref$label,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag", "active", "small", "double", "label"]);

  var Tag = tag;
  var wrapperClasses = classNames('progress-spinner', {
    'progress-spinner-active': active,
    'size-sm': small,
    'progress-spinner-double': double
  });
  var classes = classNames(className, 'sr-only');

  if (double) {
    return React__default.createElement(Tag, {
      className: wrapperClasses
    }, React__default.createElement("div", {
      className: 'progress-spinner-inner'
    }), React__default.createElement("div", {
      className: 'progress-spinner-inner'
    }), React__default.createElement(Tag, Object.assign({}, attributes, {
      className: classes
    }), label));
  }

  return React__default.createElement(Tag, {
    className: wrapperClasses
  }, React__default.createElement(Tag, Object.assign({}, attributes, {
    className: classes
  }), label));
};

var Loader = function Loader(_ref) {
  var className = _ref.className,
      text = _ref.text,
      colorText = _ref.colorText,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "text", "colorText"]);

  var modalClassnames = classNames(className, {
    'loader-fit': true
  });
  var style = {
    width: 'fit-content',
    minHeight: '-webkit-fill-available'
  };
  var styleText = colorText != null ? {
    color: colorText
  } : {
    color: 'white'
  };
  var textLoader = text != null ? text : 'Caricamento in corso';
  return React__default.createElement(Modal$1, Object.assign({}, props, {
    className: modalClassnames,
    contentClassName: 'bg-transparent d-flex align-items-center justify-content-center shadow-none',
    style: style
  }), React__default.createElement(Spinner, {
    active: true,
    label: ""
  }), React__default.createElement("span", {
    style: styleText,
    className: 'fs-5 fw-bolder'
  }, textLoader));
};

var Megamenu = function Megamenu(_ref) {
  var brand = _ref.brand,
      className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["brand", "className", "children"]);

  var _useState = useState(false),
      openNav = _useState[0],
      setOpenNav = _useState[1];

  var toggle = function toggle() {
    setOpenNav(!openNav);
  };

  var classes = classNames(className, 'has-megamenu');
  return React__default.createElement(Navbar, Object.assign({
    className: classes
  }, attributes), React__default.createElement(NavbarToggler, {
    className: 'custom-navbar-toggler',
    onClick: toggle
  }, React__default.createElement(Icon, {
    icon: 'it-list',
    size: 'sm'
  })), brand, React__default.createElement(Collapse, {
    isOpen: openNav,
    megamenu: true
  }, React__default.createElement(Nav, {
    navbar: true
  }, children)));
};

var MegamenuItem = function MegamenuItem(_ref) {
  var itemName = _ref.itemName,
      className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["itemName", "className", "children"]);

  var classes = classNames(className, 'megamenu');
  return React__default.createElement(UncontrolledDropdown, Object.assign({
    nav: true,
    tag: 'li',
    className: classes
  }, attributes), React__default.createElement(DropdownToggle, {
    caret: true,
    nav: true
  }, itemName), React__default.createElement(DropdownMenu, {
    positionFixed: true
  }, children));
};

var MegamenuFooter = function MegamenuFooter(_ref) {
  var className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "children"]);

  var classes = classNames(className, 'it-megamenu-footer');
  return React__default.createElement("div", Object.assign({
    className: classes
  }, attributes), children);
};

var MegamenuHighlightColumn = function MegamenuHighlightColumn(_ref) {
  var description = _ref.description,
      className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["description", "className", "children"]);

  var classes = classNames(className, 'it-vertical', {
    'it-description': description
  });
  return React__default.createElement(Col, Object.assign({}, attributes), React__default.createElement(Row, {
    className: 'max-height-col'
  }, React__default.createElement(Col, {
    className: classes
  }, description ? React__default.createElement("div", {
    className: 'description-content'
  }, children) : React__default.createElement(React__default.Fragment, null, children))));
};

var Modal = function Modal(_ref) {
  var withIcon = _ref.withIcon,
      withLinkList = _ref.withLinkList,
      popConfirm = _ref.popConfirm,
      modalClassName = _ref.modalClassName,
      align = _ref.align,
      scrollable = _ref.scrollable,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["withIcon", "withLinkList", "popConfirm", "modalClassName", "align", "scrollable", "className"]);

  var isAligned = align != null && ['left', 'right'].includes(align);
  var modalDialogClassnames = classNames(modalClassName, {
    'alert-modal': withIcon,
    'it-dialog-link-list': withLinkList,
    'popconfirm-modal': popConfirm,
    'it-dialog-scrollable': scrollable && isAligned
  });
  var modalClassnames = classNames(className, {
    'modal-dialog-left': align === 'left',
    'modal-dialog-right': align === 'right'
  });
  return React__default.createElement(Modal$1, Object.assign({}, props, {
    scrollable: !isAligned && scrollable,
    className: modalClassnames,
    modalClassName: modalDialogClassnames
  }));
};

var ModalHeader = function ModalHeader(_ref) {
  var icon = _ref.icon,
      className = _ref.className,
      children = _ref.children,
      toggle = _ref.toggle,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'h5' : _ref$tag,
      _ref$wrapTag = _ref.wrapTag,
      WrapTag = _ref$wrapTag === void 0 ? 'div' : _ref$wrapTag,
      _ref$closeAriaLabel = _ref.closeAriaLabel,
      closeAriaLabel = _ref$closeAriaLabel === void 0 ? 'Close' : _ref$closeAriaLabel,
      close = _ref.close,
      _ref$charCode = _ref.charCode,
      charCode = _ref$charCode === void 0 ? 215 : _ref$charCode,
      cssModule = _ref.cssModule,
      props = _objectWithoutPropertiesLoose(_ref, ["icon", "className", "children", "Util", "toggle", "tag", "wrapTag", "closeAriaLabel", "close", "charCode", "cssModule"]);

  var classes = mapToCssModules(classNames(className, 'modal-header'), cssModule);
  var CloseButton;

  if (!close && toggle) {
    var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
    CloseButton = React__default.createElement("button", {
      type: 'button',
      onClick: toggle,
      className: mapToCssModules('close', cssModule),
      "aria-label": closeAriaLabel
    }, React__default.createElement("span", {
      "aria-hidden": true
    }, closeIcon));
  }

  return React__default.createElement(WrapTag, Object.assign({}, props, {
    className: classes
  }), icon != null ? React__default.createElement(Icon, {
    icon: icon
  }) : null, React__default.createElement(Tag, {
    className: mapToCssModules('modal-title', cssModule)
  }, children), close || CloseButton);
};

var ModalBody = function ModalBody(props) {
  return React__default.createElement(ModalBody$1, Object.assign({}, props));
};

var ModalFooter = function ModalFooter(props) {
  return React__default.createElement(ModalFooter$1, Object.assign({}, props));
};

var Pager = function Pager(_ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'nav' : _ref$tag,
      _ref$listTag = _ref.listTag,
      ListTag = _ref$listTag === void 0 ? 'ul' : _ref$listTag,
      listClassName = _ref.listClassName,
      total = _ref.total,
      currentPage = _ref.currentPage,
      pageSize = _ref.pageSize,
      elementsNumber = _ref.elementsNumber,
      showNumbers = _ref.showNumbers,
      showPrevious = _ref.showPrevious,
      showNext = _ref.showNext,
      showJumpTo = _ref.showJumpTo,
      showSimpleMode = _ref.showSimpleMode,
      showResponsive = _ref.showResponsive,
      numberOfPagesToShow = _ref.numberOfPagesToShow,
      showDisableActive = _ref.showDisableActive,
      showPageChanger = _ref.showPageChanger,
      childToParent = _ref.childToParent,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag", "listTag", "listClassName", "children", "total", "currentPage", "pageSize", "elementsNumber", "showNumbers", "showPrevious", "showNext", "showJumpTo", "showSimpleMode", "showResponsive", "numberOfPagesToShow", "showDisableActive", "showPageChanger", "childToParent"]);

  var Tag = tag;
  var classes = classNames(className, 'pagination-wrapper', {
    'pagination-total': total
  });
  var listClasses = classNames(listClassName, 'pagination');

  var _ref2 = total || {},
      ariaLabel = _ref2.ariaLabel;

  var totalAriaLabel = ariaLabel ? React__default.createElement("span", {
    className: 'sr-only'
  }, ariaLabel) : null;
  var initialPageValue = currentPage ? Number(currentPage) : 1;
  var pageSizeValue = pageSize ? Number(pageSize) : 10;
  var elementsNumberValue = elementsNumber ? Number(elementsNumber) : 0;
  var pagesCount = Math.ceil(elementsNumberValue / pageSizeValue);
  var numberOfPagesToShowValue = Number(numberOfPagesToShow);
  var pageChangerMultiples = showPageChanger ? Number(showPageChanger) : 1;
  var ChildToParent = childToParent ? true : false; //Gestione dei dati da inviare al parent all'esterno

  var _useState = useState(initialPageValue),
      currentPageValue = _useState[0],
      setCurrentPage = _useState[1];

  console.info("valore : " + currentPageValue);
  /*if (Number(currentPage) !== initialPageValue){
    setCurrentPage(initialPageValue);
  }*/
  //Gestione della select del Page Changer

  var defaultOptions = [];

  for (var i = 1; i < pagesCount + 1; i++) {
    if (i % pageChangerMultiples == 0) {
      defaultOptions[i] = {
        'value': i,
        'label': 'Pagina: ' + i
      };
    } else if (i == pagesCount) {
      defaultOptions[i] = {
        'value': i,
        'label': 'Pagina: ' + i
      };
    }
  }

  var _useState2 = useState(false),
      dropdownToggle = _useState2[0],
      setDropdownToggle = _useState2[1];

  var clickHandler = function clickHandler(event) {
    var page = Number(event.currentTarget.dataset.pageValue);
    setCurrentPage(page);
  };

  var PageJumper = function PageJumper() {
    return React__default.createElement(FormGroup, null, React__default.createElement(Input$1, {
      id: 'jumpToPage',
      type: 'text',
      className: 'form-control',
      maxLength: 2,
      label: 'Vai a ...',
      placeholder: 'Vai a ...',
      defaultValue: currentPageValue,
      onKeyPress: funzioneKeyPress
    }));
  };

  function funzioneKeyPress(e) {
    if (e.key === 'Enter') {
      if (e.target.value && e.target.value > 0 && e.target.value <= pagesCount) {
        setCurrentPage(e.target.value * 1);

        if (ChildToParent) {
          childToParent(e.target.value * 1);
        }
      }
    }
  }

  return React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes), React__default.createElement(ListTag, {
    className: listClasses
  }, currentPageValue == 1 && React__default.createElement(PaginationItem, {
    disabled: true
  }, React__default.createElement(PaginationLink, {
    href: '#',
    className: 'text',
    onClick: function onClick(e) {
      e.preventDefault(), setCurrentPage(currentPageValue - 1), ChildToParent ? childToParent(currentPageValue - 1) : '';
    }
  }, showPrevious ? '' : React__default.createElement(Icon, {
    icon: 'it-chevron-left',
    "aria-label": 'Precedente'
  }), showPrevious ? showPrevious : '')), currentPageValue > 1 && React__default.createElement(PaginationItem, {
    disabled: showDisableActive
  }, React__default.createElement(PaginationLink, {
    href: '#',
    className: 'text',
    onClick: function onClick(e) {
      e.preventDefault(), setCurrentPage(currentPageValue - 1), ChildToParent ? childToParent(currentPageValue - 1) : '';
    }
  }, showPrevious ? '' : React__default.createElement(Icon, {
    icon: 'it-chevron-left',
    "aria-label": 'Precedente'
  }), showPrevious ? showPrevious : '')), showSimpleMode && currentPageValue >= 1 && React__default.createElement(PaginationItem, {
    key: 1
  }, React__default.createElement(PaginationLink, {
    href: "#",
    className: currentPageValue != 1 ? 'd-none d-sm-flex' : '',
    "aria-current": 1 === currentPageValue && !showSimpleMode ? 'page' : undefined,
    onClick: function onClick(e) {
      e.preventDefault(), ChildToParent ? childToParent(1) : '';
    }
  }, " ", currentPageValue)), !showSimpleMode && currentPageValue >= 1 && React__default.createElement(PaginationItem, {
    key: 1
  }, React__default.createElement(PaginationLink, {
    href: "#",
    className: currentPageValue != 1 ? 'd-none d-sm-flex' : '',
    "aria-current": 1 === currentPageValue && !showSimpleMode ? 'page' : undefined,
    onClick: function onClick(e) {
      e.preventDefault(), setCurrentPage(1), ChildToParent ? childToParent(1) : '';
    }
  }, " ", showResponsive && 1 === currentPageValue ? showResponsive + ': ' + 1 : 1)), Math.ceil(currentPageValue - numberOfPagesToShowValue / 2) > 2 && pageSize != numberOfPagesToShow && window.innerWidth > 500 && React__default.createElement(PaginationItem, null, React__default.createElement(PaginationLink, {
    tag: 'span'
  }, showResponsive && window.innerWidth <= 500 ? '' : '…')), showNumbers ? Array(pagesCount).fill(0).map(function (_, i) {
    return i + 1 > 1 && i + 1 > Math.floor(currentPageValue - numberOfPagesToShowValue / 2) && i + 1 <= Math.floor(currentPageValue + numberOfPagesToShowValue / 2) && i + 1 < pagesCount ? React__default.createElement(PaginationItem, {
      key: i
    }, React__default.createElement(PaginationLink, {
      href: "#",
      "aria-current": i + 1 === currentPageValue ? 'page' : undefined,
      onClick: function onClick(e) {
        e.preventDefault(), i + 1 == currentPageValue ? '' : setCurrentPage(i + 1), ChildToParent ? childToParent(i + 1) : '';
      }
    }, i + 1)) : '';
  }) : '', showResponsive && window.innerWidth > 500 ? Array(pagesCount).fill(0).map(function (_, i) {
    return i + 1 > 1 && i + 1 > Math.floor(currentPageValue - numberOfPagesToShowValue / 2) && i + 1 <= Math.floor(currentPageValue + numberOfPagesToShowValue / 2) && i < pagesCount - 1 ? //&&i+1 == currentPageValue1?
    React__default.createElement(PaginationItem, {
      key: i
    }, React__default.createElement(PaginationLink, {
      href: "#",
      className: i + 1 != currentPageValue ? 'd-none d-sm-flex' : '',
      "aria-current": i + 1 === currentPageValue ? 'page' : undefined,
      onClick: function onClick(e) {
        e.preventDefault(), setCurrentPage(i + 1), ChildToParent ? childToParent(i + 1) : '';
      }
    }, i + 1 == currentPageValue ? showResponsive + ': ' + (i + 1) : i + 1)) : '';
  }) : '', showResponsive && window.innerWidth <= 500 ? Array(pagesCount).fill(0).map(function (_, i) {
    return i + 1 > 1 && i + 1 > Math.floor(currentPageValue - numberOfPagesToShowValue / 2) && i + 1 <= Math.floor(currentPageValue + numberOfPagesToShowValue / 2) && i < pagesCount - 1 && //&&i+1 == currentPageValue1?
    i + 1 == currentPageValue ? React__default.createElement(PaginationItem, {
      key: i
    }, React__default.createElement(PaginationLink, {
      href: "#",
      className: i + 1 != currentPageValue ? 'd-none d-sm-flex' : '',
      "aria-current": i + 1 === currentPageValue ? 'page' : undefined,
      onClick: function onClick(e) {
        e.preventDefault(), setCurrentPage(i + 1), ChildToParent ? childToParent(i + 1) : '';
      }
    }, showResponsive + ': ' + (i + 1))) : '';
  }) : '', !showSimpleMode && currentPageValue + Math.ceil(numberOfPagesToShowValue / 2) < pagesCount && React__default.createElement(PaginationItem, {
    className: 'd-none d-sm-block'
  }, React__default.createElement(PaginationLink, {
    tag: 'span'
  }, showResponsive && window.innerWidth <= 500 ? '' : '…')), showSimpleMode && currentPageValue <= pagesCount && React__default.createElement(PaginationItem, {
    className: 'd-none d-sm-block'
  }, React__default.createElement(PaginationLink, {
    tag: 'span'
  }, "/")), pagesCount > 1 && currentPageValue <= pagesCount && React__default.createElement(PaginationItem, {
    key: pagesCount
  }, React__default.createElement(PaginationLink, {
    href: "#",
    className: currentPageValue != pagesCount ? 'd-none d-sm-flex' : '',
    "aria-current": pagesCount === currentPageValue ? 'page' : undefined,
    onClick: function onClick(e) {
      e.preventDefault(), setCurrentPage(pagesCount), ChildToParent ? childToParent(pagesCount) : '';
    }
  }, showResponsive && pagesCount === currentPageValue ? showResponsive + ': ' + pagesCount : pagesCount)), currentPageValue < pagesCount && React__default.createElement(PaginationItem, {
    disabled: showDisableActive
  }, React__default.createElement(PaginationLink, {
    href: '#',
    className: 'text',
    onClick: function onClick(e) {
      e.preventDefault(), setCurrentPage(currentPageValue + 1), ChildToParent ? childToParent(currentPageValue + 1) : '';
    }
  }, showNext ? '' : React__default.createElement(Icon, {
    icon: 'it-chevron-right',
    "aria-label": 'Successivo'
  }), showNext ? showNext : '')), currentPageValue === pagesCount && React__default.createElement(PaginationItem, {
    disabled: true
  }, React__default.createElement(PaginationLink, {
    href: '#',
    className: 'text',
    onClick: function onClick(e) {
      e.preventDefault(), setCurrentPage(currentPageValue + 1), ChildToParent ? childToParent(currentPageValue + 1) : '';
    }
  }, showNext ? '' : React__default.createElement(Icon, {
    icon: 'it-chevron-right',
    "aria-label": 'Successivo'
  }), showNext ? showNext : ''))), total ? React__default.createElement("p", null, totalAriaLabel, ' ' + currentPageValue + ' di ' + pagesCount) : null, showJumpTo && React__default.createElement(PageJumper, null), showPageChanger && React__default.createElement(Dropdown, {
    isOpen: dropdownToggle,
    toggle: function toggle() {
      return setDropdownToggle(!dropdownToggle);
    }
  }, React__default.createElement(DropdownToggle, {
    tag: 'a',
    id: 'pagerChanger',
    className: 'btn shadow-none'
  }, "Pagina ", currentPageValue), React__default.createElement(DropdownMenu, null, React__default.createElement(LinkList, null, defaultOptions.map(function (values) {
    return React__default.createElement(LinkListItem, {
      "data-page-value": values.value,
      onClick: clickHandler
    }, values.label);
  })))));
};

var isCustomLegendObject = function isCustomLegendObject(legend) {
  return legend != null && typeof legend === 'object' && 'content' in legend;
};
var Rating = function Rating(_ref) {
  var className = _ref.className,
      inputs = _ref.inputs,
      legend = _ref.legend,
      name = _ref.name,
      readOnly = _ref.readOnly,
      value = _ref.value,
      wrapperClassName = _ref.wrapperClassName,
      testId = _ref.testId,
      _ref$labelTemplate = _ref.labelTemplate,
      labelTemplate = _ref$labelTemplate === void 0 ? function (value) {
    return "Valuta " + value + " stelle su 5";
  } : _ref$labelTemplate,
      _ref$onChangeRating = _ref.onChangeRating,
      onChangeRating = _ref$onChangeRating === void 0 ? noop : _ref$onChangeRating,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "inputs", "legend", "name", "readOnly", "value", "wrapperClassName", "testId", "labelTemplate", "onChangeRating"]);

  // Input data
  // On the DOM we have to go from 5 to 1
  var safeInputs = (inputs || []).reverse(); // Fields

  var labelFn = labelTemplate;

  var _onChange = readOnly ? noop : onChangeRating;

  var wrapperClasses = classNames(wrapperClassName, {
    'rating rating-read-only': readOnly,
    'rating rating-label': legend
  });
  var fieldClasses = classNames(className);
  var extraFieldAttrs = readOnly ? {
    'aria-hidden': true
  } : {}; // Legend

  var isLegendString = typeof legend === 'string';
  var legendClass = '';
  var legendText = legend;

  if (isCustomLegendObject(legend)) {
    legendClass = classNames({
      'visually-hidden': legend.srOnly
    });
    legendText = legend.content;
  }

  var legendContent = isCustomLegendObject(legend) || isLegendString ? React__default.createElement("legend", {
    className: legendClass
  }, legendText) : legend;
  return React__default.createElement(FormGroup, Object.assign({
    cssModule: {
      'form-group': 'rating'
    },
    tag: 'fieldset',
    className: wrapperClasses,
    "data-testid": testId
  }, attributes), legend && legendContent, safeInputs.map(function (id, i) {
    var currentValue = 5 - i;
    return React__default.createElement(Fragment, {
      key: id
    }, React__default.createElement(Input, Object.assign({
      type: 'radio',
      id: id,
      name: name,
      value: String(currentValue),
      cssModule: {
        'form-control': ''
      },
      className: fieldClasses,
      onChange: function onChange() {
        return _onChange(currentValue, name);
      },
      checked: value === currentValue,
      disabled: readOnly
    }, extraFieldAttrs)), React__default.createElement(Label, {
      className: 'full',
      for: id,
      "data-element": "feedback-rate-" + currentValue
    }, React__default.createElement(Icon, {
      icon: 'it-star-full',
      size: 'sm'
    }), React__default.createElement("span", {
      className: 'visually-hidden'
    }, labelFn(currentValue))));
  }));
};

var ResponsiveImage = function ResponsiveImage(_ref) {
  var alt = _ref.alt,
      attributes = _objectWithoutPropertiesLoose(_ref, ["alt"]);

  return React__default.createElement("div", {
    className: 'img-responsive-wrapper'
  }, React__default.createElement("div", {
    className: 'img-responsive'
  }, React__default.createElement("div", {
    className: 'img-wrapper'
  }, React__default.createElement("img", Object.assign({}, attributes, {
    alt: alt
  })))));
};

var Skiplink = function Skiplink(_ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag"]);

  var Tag = tag;
  var classes = classNames(className, 'skiplinks');
  return React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes));
};

var SkiplinkItem = function SkiplinkItem(_ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'a' : _ref$tag,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? true : _ref$focusable,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag", "focusable"]);

  var Tag = tag;
  var classes = classNames(className, 'sr-only', {
    'sr-only-focusable': focusable
  }); // Add an extra href for focusable if the user passes an onClick rather than href prop

  var extraHref = attributes.onClick ? {
    href: '#'
  } : {};
  return React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes, extraHref));
};

var Toggle = function Toggle(_ref) {
  var label = _ref.label,
      rest = _objectWithoutPropertiesLoose(_ref, ["label"]);

  return React__default.createElement("div", {
    className: 'toggles'
  }, React__default.createElement(Label, {
    check: true
  }, label, React__default.createElement(Input$1, Object.assign({}, rest, {
    type: 'checkbox'
  })), React__default.createElement("span", {
    className: 'lever'
  })));
};

var Sidebar = function Sidebar(_ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$secondary = _ref.secondary,
      secondary = _ref$secondary === void 0 ? false : _ref$secondary,
      _ref$left = _ref.left,
      left = _ref$left === void 0 ? false : _ref$left,
      _ref$right = _ref.right,
      right = _ref$right === void 0 ? false : _ref$right,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag", "secondary", "left", "right", "dark"]);

  var Tag = tag;
  var wrapperClasses = classNames('sidebar-wrapper', className, {
    'it-line-left-side': left,
    'it-line-right-side': right,
    'theme-dark': dark
  });
  var wrapperClassesLinkList = classNames('sidebar-linklist-wrapper', {
    'linklist-secondary': secondary
  });

  if (secondary) {
    return React__default.createElement(Tag, Object.assign({}, attributes, {
      className: wrapperClassesLinkList
    }));
  }

  return React__default.createElement(Tag, {
    className: wrapperClasses
  }, React__default.createElement(Tag, Object.assign({}, attributes, {
    className: wrapperClassesLinkList
  })));
};

var Progress = function Progress(_ref) {
  var _classNames;

  var wrapperClassName = _ref.wrapperClassName,
      className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      value = _ref.value,
      label = _ref.label,
      _ref$indeterminate = _ref.indeterminate,
      indeterminate = _ref$indeterminate === void 0 ? false : _ref$indeterminate,
      color = _ref.color,
      attributes = _objectWithoutPropertiesLoose(_ref, ["wrapperClassName", "className", "tag", "value", "label", "indeterminate", "color", "role"]);

  var Tag = tag;

  if (!isNumber(value) && !indeterminate) {
    logError("The passed \"value\" is not a valid number. You passed \"" + value + "\"");
  }

  var numericValue = Number(value);
  var wrapperClasses = classNames('progress-bar-wrapper');
  var secondaryWrapperClasses = classNames(wrapperClassName === true ? className : wrapperClassName, 'progress', {
    'progress-indeterminate': indeterminate,
    'progress-color': color
  });
  var classes = classNames(className, 'progress-bar', (_classNames = {}, _classNames["bg-" + color] = color, _classNames));

  if (label && numericValue) {
    return React__default.createElement(Tag, {
      className: wrapperClasses
    }, React__default.createElement("div", {
      className: 'progress-bar-label'
    }, React__default.createElement("span", {
      className: 'sr-only'
    }, label), numericValue + '%'), React__default.createElement(Tag, {
      className: secondaryWrapperClasses
    }, React__default.createElement("div", Object.assign({}, attributes, {
      className: classes,
      role: 'progressbar',
      style: {
        width: numericValue + '%'
      },
      "aria-valuenow": numericValue,
      "aria-valuemin": 0,
      "aria-valuemax": 100
    }))));
  }

  return React__default.createElement(Tag, {
    className: secondaryWrapperClasses
  }, React__default.createElement("div", {
    className: 'progress-bar-label'
  }, React__default.createElement("span", {
    className: 'sr-only'
  }, label)), React__default.createElement("div", Object.assign({}, attributes, {
    className: classes,
    role: 'progressbar',
    style: {
      width: numericValue + '%'
    },
    "aria-valuenow": numericValue,
    "aria-valuemin": 0,
    "aria-valuemax": 100
  })));
};

var PointList = function PointList(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "className"]);

  var Tag = tag;
  var classes = classNames('point-list-wrapper my-4', className);
  return React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes));
};

var PointListBody = function PointListBody(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "className", "children"]);

  var Tag = tag;
  var classes = classNames("point-list", className);
  return React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes), children);
};

var PointListAside = function PointListAside(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      className = _ref.className,
      date = _ref.date,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "className", "date", "children"]);

  var Tag = tag;
  var classes = classNames('point-hour font-monospace', className);
  var classesData = classNames('point-list-aside point-list-primary col-2 col-sm-2', className);

  if (date) {
    var data = new Date(date);
    var mese = new Date(date).toLocaleDateString('default', {
      month: 'short'
    });
    var giorno = new Date(date).toLocaleDateString('default', {
      day: '2-digit'
    });
    return React__default.createElement(Tag, Object.assign({
      className: classesData
    }, attributes), React__default.createElement("div", {
      className: 'point-year font-monospace '
    }, data.getFullYear()), React__default.createElement("div", {
      className: 'point-date font-monospace '
    }, giorno), React__default.createElement("div", {
      className: 'point-month font-monospace '
    }, mese));
  }

  return React__default.createElement("div", {
    className: 'point-list-aside point-list-primary col-2 col-sm-2'
  }, React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes), children));
};

var PointListContent = function PointListContent(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'h3' : _ref$tag,
      className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "className", "children"]);

  var Tag = tag;
  var classes = classNames("card-title h5", className);
  return React__default.createElement("div", {
    className: 'point-list-content col-10 col-sm-10'
  }, React__default.createElement("div", {
    className: "card card-teaser shadow rounded"
  }, React__default.createElement("div", {
    className: "card-body"
  }, React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes), children))));
};

var BottomNav = function BottomNav(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'nav' : _ref$tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag"]);

  var Tag = tag;
  return React__default.createElement(Tag, {
    className: 'bottom-nav'
  }, React__default.createElement("ul", Object.assign({}, attributes)));
};

var BottomNavItem = function BottomNavItem(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      badge = _ref.badge,
      _ref$alert = _ref.alert,
      alert = _ref$alert === void 0 ? false : _ref$alert,
      url = _ref.url,
      srText = _ref.srText,
      _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === void 0 ? 'it-comment' : _ref$iconName,
      label = _ref.label,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'a' : _ref$tag,
      onLinkClick = _ref.onLinkClick,
      link = _ref.link,
      attributes = _objectWithoutPropertiesLoose(_ref, ["active", "badge", "alert", "url", "srText", "iconName", "label", "tag", "onLinkClick", "link"]);

  var Tag = tag;
  var activeClass = classNames({
    active: active
  });
  var badgeWrapper = Boolean(badge) && React__default.createElement("div", {
    className: 'badge-wrapper'
  }, React__default.createElement("span", {
    className: 'bottom-nav-badge'
  }, badge));
  var alertWrapper = Boolean(alert) && React__default.createElement("div", {
    className: 'badge-wrapper'
  }, React__default.createElement("span", {
    className: 'bottom-nav-alert'
  }));
  return React__default.createElement("li", Object.assign({}, attributes), React__default.createElement(Tag, {
    href: url || link || '#',
    className: activeClass,
    onClick: onLinkClick
  }, badgeWrapper, alertWrapper, React__default.createElement(Icon, {
    icon: iconName
  }), React__default.createElement("span", {
    className: 'bottom-nav-label'
  }, label, srText ? React__default.createElement("span", {
    className: 'sr-only'
  }, srText) : null)));
};

var ThumbNav = function ThumbNav(_ref) {
  var _classNames;

  var _ref$isSmall = _ref.isSmall,
      isSmall = _ref$isSmall === void 0 ? false : _ref$isSmall,
      _ref$fixedWidth = _ref.fixedWidth,
      fixedWidth = _ref$fixedWidth === void 0 ? false : _ref$fixedWidth,
      _ref$isVertical = _ref.isVertical,
      isVertical = _ref$isVertical === void 0 ? false : _ref$isVertical,
      _ref$noZoomOnHover = _ref.noZoomOnHover,
      noZoomOnHover = _ref$noZoomOnHover === void 0 ? false : _ref$noZoomOnHover,
      rowItems = _ref.rowItems,
      overlayOnHover = _ref.overlayOnHover,
      position = _ref.position,
      attributes = _objectWithoutPropertiesLoose(_ref, ["isSmall", "fixedWidth", "isVertical", "noZoomOnHover", "rowItems", "overlayOnHover", "position"]);

  var classes = classNames('thumb-nav', (_classNames = {
    'thumb-nav-fixed': fixedWidth,
    'thumb-nav-small': isSmall,
    'thumb-nav-vertical': isVertical || position === 'left' || position === 'right',
    'thumb-nav-nozoom': noZoomOnHover
  }, _classNames["thumb-nav-" + overlayOnHover] = overlayOnHover, _classNames["thumb-nav-" + position] = position, _classNames['thumb-nav-auto'] = rowItems != null, _classNames["thumb-nav-auto-" + rowItems] = rowItems != null, _classNames));
  return React__default.createElement("ul", Object.assign({
    className: classes
  }, attributes));
};

var ThumbNavItem = function ThumbNavItem(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      targetUrl = _ref.targetUrl,
      imageUrl = _ref.imageUrl,
      actionDescription = _ref.actionDescription,
      attributes = _objectWithoutPropertiesLoose(_ref, ["active", "targetUrl", "imageUrl", "actionDescription"]);

  var classes = classNames([{
    active: active
  }, "ratio", "ratio-3x2"]);
  return React__default.createElement("li", Object.assign({}, attributes), React__default.createElement("a", {
    href: targetUrl,
    className: classes
  }, React__default.createElement("img", {
    src: imageUrl,
    alt: actionDescription
  })));
};

var CookieBar = function CookieBar(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "className"]);

  var Tag = tag;
  var wrapperClasses = classNames('cookiebar show', className);
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: wrapperClasses
  }));
};

var CookieBarButtons = function CookieBarButtons(_ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag"]);

  var Tag = tag;
  var buttonClasses = classNames(className, 'cookiebar-buttons');
  return React__default.createElement(Tag, Object.assign({
    className: buttonClasses
  }, attributes));
};

var CookieBarButton = function CookieBarButton(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'button' : _ref$tag,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "className"]);

  var Tag = tag;
  var activeClass = classNames(className, 'cookiebar-btn');
  return React__default.createElement(Tag, Object.assign({
    className: activeClass
  }, attributes));
};

var Chip = function Chip(_ref) {
  var _classNames;

  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$simple = _ref.simple,
      simple = _ref$simple === void 0 ? false : _ref$simple,
      _ref$large = _ref.large,
      large = _ref$large === void 0 ? false : _ref$large,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "color", "tag", "simple", "large", "disabled"]);

  var Tag = tag;
  var classes = classNames('chip', className, (_classNames = {
    'chip-simple': simple,
    'chip-lg': large,
    'chip-disabled': disabled
  }, _classNames["chip-" + color] = color, _classNames));
  return React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes));
};

var ChipLabel = function ChipLabel(_ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'span' : _ref$tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "tag"]);

  var Tag = tag;
  var classes = classNames(className, 'chip-label');
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: classes
  }));
};

var defaultFonts = ['Titillium Web:300,400,600,700:latin-ext', 'Lora:400,700:latin-ext', 'Roboto Mono:400,700:latin-ext'];
function useFontLoader(_ref) {
  var fonts = _ref.fonts;
  useEffect(function () {
    if (typeof window !== 'undefined') {
      var WebFont = require('webfontloader');

      WebFont.load({
        custom: {
          families: [].concat(defaultFonts, fonts || [])
        }
      });
    }
  }, [fonts]);
}
var FontLoader = function FontLoader(props) {
  useFontLoader(props);
  return null;
};

var Dimmer = function Dimmer(_ref) {
  var _classNames;

  var icon = _ref.icon,
      color = _ref.color,
      className = _ref.className,
      wrapperClassName = _ref.wrapperClassName,
      attributes = _objectWithoutPropertiesLoose(_ref, ["icon", "color", "className", "wrapperClassName"]);

  var children = attributes.children,
      rest = _objectWithoutPropertiesLoose(attributes, ["children"]);

  var classes = classNames('dimmer', wrapperClassName === true ? className : wrapperClassName, (_classNames = {}, _classNames["dimmer-" + color] = color, _classNames));
  var innerClasses = classNames('dimmer-inner', className);
  var dimmerIcon = icon && React__default.createElement("div", {
    className: 'dimmer-icon'
  }, React__default.createElement(Icon, {
    icon: icon
  }));
  return React__default.createElement("div", Object.assign({
    className: classes
  }, rest, {
    style: {
      display: 'flex'
    }
  }), React__default.createElement("div", Object.assign({
    className: innerClasses
  }, rest), dimmerIcon, children));
};

var DimmerButtons = function DimmerButtons(_ref) {
  var className = _ref.className,
      _ref$single = _ref.single,
      single = _ref$single === void 0 ? false : _ref$single,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? true : _ref$dark,
      attributes = _objectWithoutPropertiesLoose(_ref, ["color", "className", "single", "dark"]);

  var children = attributes.children,
      rest = _objectWithoutPropertiesLoose(attributes, ["children"]);

  var classes = classNames('dimmer-buttons', className, {
    'bg-dark': dark,
    'single-button': single
  });
  return React__default.createElement("div", Object.assign({
    className: classes
  }, rest), children);
};

var addTime = function addTime(value, maxValue) {
  var currTime = Number(value);
  return currTime >= maxValue ? value : (currTime + 1).toString();
};
var subtractTime = function subtractTime(value, minValue) {
  var currTime = Number(value);
  return currTime <= minValue ? value : (currTime - 1).toString();
};
var formatTime = function formatTime(value) {
  return ("0" + value).substr(-2);
};

var TimeInputContainer = function TimeInputContainer(_ref) {
  var wrapperClass = _ref.wrapperClass,
      children = _ref.children,
      label = _ref.label,
      id = _ref.id,
      infoText = _ref.infoText,
      button = _ref.button,
      infoTextClass = _ref.infoTextClass,
      invalid = _ref.invalid;
  var infoId = id ? id + "Description" : undefined;
  var activeClass = 'active';
  return React__default.createElement("div", {
    className: classNames(wrapperClass)
  }, React__default.createElement("div", {
    className: 'input-group'
  }, children, React__default.createElement("label", {
    htmlFor: id,
    className: classNames(activeClass, {
      'error-label': invalid
    })
  }, label), React__default.createElement("small", {
    id: infoId,
    className: infoTextClass
  }, infoText), React__default.createElement("div", {
    className: 'input-group-append'
  }, button)));
};

var TimeInput = function TimeInput(_ref2) {
  var _ref2$dark = _ref2.dark,
      dark = _ref2$dark === void 0 ? false : _ref2$dark,
      _ref2$onBlur = _ref2.onBlur,
      _onBlur = _ref2$onBlur === void 0 ? noop : _ref2$onBlur,
      label = _ref2.label,
      controlsLabel = _ref2.controlsLabel,
      _ref2$invalid = _ref2.invalid,
      invalid = _ref2$invalid === void 0 ? false : _ref2$invalid,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? '' : _ref2$value,
      id = _ref2.id,
      placeholder = _ref2.placeholder,
      srText = _ref2.srText,
      hoursLabel = _ref2.hoursLabel,
      minutesLabel = _ref2.minutesLabel,
      increaseHoursLabel = _ref2.increaseHoursLabel,
      increaseMinutesLabel = _ref2.increaseMinutesLabel,
      decreaseHoursLabel = _ref2.decreaseHoursLabel,
      decreaseMinutesLabel = _ref2.decreaseMinutesLabel,
      attributes = _objectWithoutPropertiesLoose(_ref2, ["dark", "onBlur", "label", "controlsLabel", "invalid", "value", "id", "placeholder", "srText", "hoursLabel", "minutesLabel", "increaseHoursLabel", "increaseMinutesLabel", "decreaseHoursLabel", "decreaseMinutesLabel"]);

  var _value$split = value.split(':'),
      initialHours = _value$split[0],
      initialMinutes = _value$split[1];

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = useState(initialHours || '00'),
      hours = _useState2[0],
      setHours = _useState2[1];

  var _useState3 = useState(initialMinutes || '00'),
      minutes = _useState3[0],
      setMinutes = _useState3[1];

  var _useState4 = useState(initialHours && initialMinutes ? initialHours + ":" + initialMinutes : ''),
      time = _useState4[0],
      setTime = _useState4[1];

  var _useState5 = useState(false),
      isFocused = _useState5[0],
      toggleFocus = _useState5[1];

  var button = React__default.createElement("button", {
    type: 'button',
    className: 'btn-time',
    onClick: function onClick() {
      setIsOpen(!isOpen);
      if (isOpen) _onBlur(time);
    }
  }, React__default.createElement(Icon, {
    icon: 'it-clock'
  }));

  var onHoursChange = function onHoursChange(value) {
    var formattedValue = formatTime(value);
    setHours(isNaN(Number(formattedValue)) ? "00" : formattedValue);
    setTime(formattedValue + ":" + minutes);
  };

  var onMinutesChange = function onMinutesChange(value) {
    var formattedValue = formatTime(value);
    setMinutes(isNaN(Number(formattedValue)) ? "00" : formattedValue);
    setTime(hours + ":" + formattedValue);
  };

  var onTimeChange = function onTimeChange(value) {
    var _value$split2 = value.split(':'),
        hours = _value$split2[0],
        minutes = _value$split2[1];

    onHoursChange(hours == null ? void 0 : hours.trim());
    onMinutesChange(minutes == null ? void 0 : minutes.trim());
    setTime(value);
  };

  var infoTextControlClass = getInfoTextControlClass(attributes, attributes.cssModule);

  var _getClasses = getClasses(attributes.className, _extends({}, attributes, {
    normalized: Boolean(attributes.normalized),
    inputPassword: false,
    formControlClass: 'form-control',
    infoTextControlClass: infoTextControlClass,
    isFocused: isFocused,
    originalWrapperClass: attributes.wrapperClassName || attributes.wrapperClass
  }), attributes.cssModule),
      infoTextClass = _getClasses.infoTextClass,
      wrapperClass = _getClasses.wrapperClass;

  return React__default.createElement("div", {
    className: classNames('it-timepicker-wrapper', {
      'theme-dark': dark
    })
  }, React__default.createElement("section", {
    className: 'time-spinner'
  }, React__default.createElement("div", {
    className: 'error_container',
    role: 'alert',
    "aria-atomic": 'true'
  }), React__default.createElement("fieldset", null, React__default.createElement("legend", null, React__default.createElement("span", {
    className: 'sr-only'
  }, srText)), React__default.createElement("div", null, React__default.createElement("div", {
    className: 'calendar-input-container'
  }, React__default.createElement(TimeInputContainer, {
    wrapperClass: wrapperClass,
    infoTextClass: infoTextClass,
    label: label,
    infoText: attributes.infoText,
    id: id,
    button: button,
    invalid: invalid
  }, React__default.createElement(Input, Object.assign({}, attributes, {
    type: 'text',
    label: label,
    id: id,
    placeholder: placeholder,
    value: time,
    onFocus: function onFocus() {
      setIsOpen(false);
      toggleFocus(true);
    },
    onChange: function onChange(e) {
      return onTimeChange(e.target.value);
    },
    invalid: invalid,
    onBlur: function onBlur() {
      toggleFocus(false);

      _onBlur(time);
    },
    noWrapper: true
  })))))), React__default.createElement("div", {
    className: 'spinner-control',
    "aria-hidden": 'true',
    role: 'region',
    "aria-label": controlsLabel,
    tabIndex: -1,
    style: {
      display: isOpen ? 'block' : 'none'
    }
  }, React__default.createElement("div", {
    className: 'spinner-hour spinner'
  }, React__default.createElement(Input, {
    className: 'spinnerHour form-control',
    "aria-label": hoursLabel,
    type: 'number',
    value: hours,
    role: 'spinbutton',
    maxLength: 2,
    "aria-valuenow": Number(hours),
    "aria-valuemax": 23,
    "aria-valuemin": 0,
    onChange: function onChange(e) {
      return onHoursChange(e.target.value);
    }
  }), React__default.createElement("div", {
    className: 'button-wrapper'
  }, React__default.createElement("button", {
    type: 'button',
    className: 'button-hour btnHourUp',
    "aria-label": increaseHoursLabel,
    "aria-hidden": 'true',
    tabIndex: -1,
    onClick: function onClick() {
      return onHoursChange(addTime(hours, 23));
    }
  }, React__default.createElement("span", {
    className: 'icon-up'
  })), React__default.createElement("button", {
    type: 'button',
    className: 'button-hour btnHourDown',
    "aria-label": decreaseHoursLabel,
    "aria-hidden": 'true',
    tabIndex: -1,
    onClick: function onClick() {
      return onHoursChange(subtractTime(hours, 0));
    }
  }, React__default.createElement("span", {
    className: 'icon-down'
  })))), React__default.createElement("div", {
    className: 'spinner-min spinner'
  }, React__default.createElement(Input, {
    className: 'spinnerMin form-control',
    "aria-label": minutesLabel,
    type: 'number',
    value: minutes,
    role: 'spinbutton',
    maxLength: 2,
    "aria-valuenow": Number(minutes),
    "aria-valuemax": 59,
    "aria-valuemin": 0,
    onChange: function onChange(e) {
      return onMinutesChange(e.target.value);
    }
  }), React__default.createElement("div", {
    className: 'button-wrapper'
  }, React__default.createElement("button", {
    type: 'button',
    className: 'btnMinUp button-minute',
    "aria-label": increaseMinutesLabel,
    "aria-hidden": 'true',
    tabIndex: -1,
    onClick: function onClick() {
      return onMinutesChange(addTime(minutes, 59));
    }
  }, React__default.createElement("span", {
    className: 'icon-up'
  })), React__default.createElement("button", {
    type: 'button',
    className: 'btnMinDown button-minute',
    "aria-label": decreaseMinutesLabel,
    "aria-hidden": 'true',
    tabIndex: -1,
    onClick: function onClick() {
      return onMinutesChange(subtractTime(minutes, 0));
    }
  }, React__default.createElement("span", {
    className: 'icon-down'
  })))))));
};

var Timeline = function Timeline(props) {
  var className = props.className,
      attributes = _objectWithoutPropertiesLoose(props, ["className"]);

  var children = attributes.children,
      rest = _objectWithoutPropertiesLoose(attributes, ["children"]);

  var timelineWrapper = classNames(className, 'it-timeline-wrapper');
  return React__default.createElement("div", Object.assign({
    className: timelineWrapper
  }, rest), children);
};

var TimelinePin = function TimelinePin(_ref) {
  var _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === void 0 ? 'it-code-circle' : _ref$iconName,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? 'it-code-circle' : _ref$icon,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? ' ' : _ref$label,
      past = _ref.past,
      now = _ref.now,
      nowText = _ref.nowText,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["iconName", "icon", "label", "past", "now", "nowText", "className"]);

  var children = attributes.children,
      rest = _objectWithoutPropertiesLoose(attributes, ["children"]);

  var classes = classNames('timeline-element', className);
  var innerClasses = classNames('it-pin-wrapper', className, {
    'it-evidence': past,
    'it-now': now
  });
  var pinIcon = React__default.createElement("div", {
    className: 'pin-icon'
  }, React__default.createElement(Icon, {
    icon: iconName || icon
  }));
  var pinLabel = React__default.createElement("div", {
    className: 'pin-text'
  }, React__default.createElement("span", null, label));
  var pinTextNow = now && React__default.createElement("span", {
    className: 'it-now-label d-none d-lg-flex'
  }, nowText);
  return React__default.createElement("div", {
    className: classes
  }, pinTextNow, React__default.createElement("div", Object.assign({
    className: innerClasses
  }, rest), pinIcon, pinLabel), children);
};

var black = '#000';
var primary = '#06c';
var primaryDark = '#435a70';
var primaryDarker = '#17324d'; // Types here depend of react-select internal emotion dep + more parametric stuff
// @TODO: fix it this way for now, will review later on

var styles = {
  container: function container(provided) {
    return _extends({}, provided, {
      height: '2.5rem'
    });
  },
  control: function control(provided) {
    return _extends({}, provided, {
      height: '2.5rem',
      borderRadius: '0',
      borderLeft: 'none',
      borderRight: 'none',
      borderTop: 'none',
      borderBottom: "solid " + primaryDark + " 1px",
      boxShadow: 'none',
      '&:hover': {
        borderBottom: "solid " + primaryDark + " 1.25px"
      } // border style on hover

    });
  },
  dropdownIndicator: function dropdownIndicator(provided) {
    return _extends({}, provided, {
      fill: primaryDark
    });
  },
  option: function option(provided, _ref) {
    var isDisabled = _ref.isDisabled,
        isFocused = _ref.isFocused,
        isSelected = _ref.isSelected;
    return _extends({}, provided, {
      background: 'white',
      textDecoration: isFocused || isSelected ? 'underline' : 'none',
      color: isSelected ? primaryDarker : primary,
      cursor: isDisabled ? 'not-allowed' : 'pointer'
    });
  },
  placeholder: function placeholder(provided) {
    return _extends({}, provided, {
      color: primaryDarker,
      fill: primaryDark
    });
  },
  singleValue: function singleValue(provided) {
    return _extends({}, provided, {
      color: black,
      fontWeight: 'bold'
    });
  },
  valueContainer: function valueContainer(provided) {
    return _extends({}, provided, {
      height: 'fit-content'
    });
  },
  menu: function menu(provided) {
    return _extends({}, provided, {
      zIndex: 2
    });
  }
};
var errorStyles = {
  container: styles.container,
  control: function control(provided) {
    return _extends({}, provided, {
      height: '2.5rem',
      borderRadius: '0',
      borderLeft: 'none',
      borderRight: 'none',
      borderTop: 'none',
      borderBottom: "solid red 1px",
      boxShadow: 'none',
      '&:hover': {
        borderBottom: "solid red 1.25px"
      } // border style on hover

    });
  },
  dropdownIndicator: styles.dropdownIndicator,
  option: styles.option,
  placeholder: styles.placeholder,
  singleValue: styles.singleValue,
  valueContainer: styles.valueContainer,
  menu: styles.menu
};

var DropdownIndicator = function DropdownIndicator(props) {
  return React__default.createElement(components.DropdownIndicator, Object.assign({}, props), React__default.createElement(Icon, {
    icon: 'it-arrow-down-triangle',
    "aria-hidden": true
  }));
};

var Option = function Option(props) {
  return React__default.createElement("div", {
    className: 'select-pill text-primary'
  }, React__default.createElement(components.Option, Object.assign({}, props)));
};

var CustomClearText = function CustomClearText(_ref) {
  var clearText = _ref.clearText;
  return React__default.createElement(React__default.Fragment, null, clearText);
};

var Select = function Select(_ref2) {
  var _ref2$clearText = _ref2.clearText,
      clearText = _ref2$clearText === void 0 ? 'Annulla' : _ref2$clearText,
      props = _objectWithoutPropertiesLoose(_ref2, ["clearText", "icon"]);

  // @TODO: move it outside when migrating to hooks
  var ClearIndicator = function ClearIndicator(clearIndicatorProps) {
    var _clearIndicatorProps$ = clearIndicatorProps.children,
        children = _clearIndicatorProps$ === void 0 ? React__default.createElement(CustomClearText, {
      clearText: clearText
    }) : _clearIndicatorProps$,
        _clearIndicatorProps$2 = clearIndicatorProps.innerProps,
        ref = _clearIndicatorProps$2.ref,
        restInnerProps = _objectWithoutPropertiesLoose(_clearIndicatorProps$2, ["ref"]);

    return React__default.createElement("div", Object.assign({
      className: 'select-pill text-primary'
    }, restInnerProps, {
      ref: ref
    }), React__default.createElement("div", {
      style: {
        padding: '0px 5px'
      }
    }, children));
  };

  var selectComponents = _extends({}, props.components, {
    Option: Option,
    DropdownIndicator: DropdownIndicator,
    IndicatorSeparator: null
  });

  if (props.isClearable) {
    selectComponents.ClearIndicator = ClearIndicator;
  }

  useEffect(function () {
    if (props.required) {
      var ele = document.querySelector('input[name="' + props.name + '"]');

      if (ele != null && !ele.id) {
        if (props['aria-label'] != null) {
          // @ts-ignore: ignore
          ele.ariaLabel = props['aria-label'];
        }

        if (props['id'] != null) {
          // @ts-ignore: ignore
          ele.id = props['id'] + 'Required';
        }

        ele.addEventListener("invalid", function (event) {
          // @ts-ignore: ignore
          event.extId = props.id;
          props.onInvalid(event);
        }); // Viene eseguita la funzione ricevuta la prima volta che viene renderizzato l'oggetto e ogni volta che viene ripopolato il required

        if (props.onRenderRequired) {
          //Simulo il passaggio di un evento
          props.onRenderRequired({
            currentTarget: ele
          });
        }
      }
    }
  });

  if (!props.classNames) {
    props.classNames = {
      option: function option(state) {
        return state.isFocused ? 'text-secondary' : 'text-primary';
      }
    };
  }

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(SelectBase, Object.assign({}, props, {
    components: selectComponents,
    styles: props.isInvalid ? errorStyles : styles
  })), React__default.createElement("small", {
    id: props.id + 'Description',
    className: 'mb-4',
    style: {
      color: 'red'
    }
  }, props.infotext));
};

var StepperHeader = function StepperHeader(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'ul' : _ref$tag,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "className"]);

  var Tag = tag;
  var wrapperClass = classNames('steppers-header', className);
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: wrapperClass
  }));
};

var StepperContainer = function StepperContainer(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      mobile = _ref.mobile,
      dark = _ref.dark,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "mobile", "dark", "className"]);

  var Tag = tag;
  var wrapperClass = classNames('steppers', className, {
    'bg-dark': dark
  }, {
    'mobile-examples': mobile
  });
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: wrapperClass
  }));
};

var variants = {
  confirmed: 'confirmed',
  active: 'active',
  done: 'done',
  mobile: 'steppers-index',
  // @deprecated
  'steppers-index': 'steppers-index'
};
var StepperHeaderElement = function StepperHeaderElement(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'li' : _ref$tag,
      variant = _ref.variant,
      appendIcon = _ref.appendIcon,
      prependIcon = _ref.prependIcon,
      icon = _ref.icon,
      iconName = _ref.iconName,
      noLine = _ref.noLine,
      stepperNumber = _ref.stepperNumber,
      children = _ref.children,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "variant", "appendIcon", "prependIcon", "icon", "iconName", "noLine", "stepperNumber", "children", "className"]);

  var Tag = tag;
  var wrapperClasses = classNames(variant ? variants[variant] : '', className, {
    'no-line': noLine
  });
  var iconClass = classNames('icon', 'steppers-success');
  var spanClass = classNames('steppers-number');
  var iconToAppend = appendIcon || icon;
  var iconToPepend = prependIcon || iconName;
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: wrapperClasses
  }), iconToPepend && React__default.createElement(Icon, {
    icon: iconToPepend
  }), stepperNumber && React__default.createElement("span", {
    className: spanClass
  }, stepperNumber), children, iconToAppend && React__default.createElement(Icon, {
    icon: iconToAppend,
    className: iconClass
  }));
};

var StepperNav = function StepperNav(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'nav' : _ref$tag,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "className"]);

  var Tag = tag;
  var wrapperClass = classNames('steppers-nav', className);
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: wrapperClass
  }));
};

var StepperDots = function StepperDots(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'ul' : _ref$tag,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "className"]);

  var Tag = tag;
  var wrapperClass = classNames('steppers-dots', className);
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: wrapperClass
  }));
};

var contentStyleLight = {
  height: '400px',
  border: '2px dashed #eee',
  background: '#fafafa',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#333'
};
var contentStyleDark = {
  height: '400px',
  border: '2px dashed #eee',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#EEE',
  borderColor: '#aaa',
  background: '#17324d',
  opacity: 0.5
};
var StepperContent = function StepperContent(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      dark = _ref.dark,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "className", "dark"]);

  var Tag = tag;
  var classes = classNames('steppers-content', classNames);
  return React__default.createElement(Tag, Object.assign({}, attributes, {
    className: classes,
    style: dark && contentStyleDark || contentStyleLight,
    "aria-live": 'polite'
  }));
};

var StepperComponent = function StepperComponent(_ref) {
  var hash_stepper = _ref.hash_stepper,
      current_step_name = _ref.current_step_name,
      current_step_position = _ref.current_step_position;

  function class_by_position(key, current_step_name) {
    var classN = hash_stepper[key]['posizione'] < hash_stepper[current_step_name]['posizione'] ? 'confirmed' : hash_stepper[key]['posizione'] == hash_stepper[current_step_name]['posizione'] ? 'active' : '';
    return classN;
  }

  function identify_current_step_name(current_step_position, hash_stepper) {
    var name = '';
    Object.keys(hash_stepper).map(function (key) {
      if (hash_stepper[key].posizione == current_step_position) {
        name = key;
      }
    });
    return name;
  }

  var step_name = current_step_position ? identify_current_step_name(current_step_position, hash_stepper) : current_step_name;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Row, {
    className: "steppers"
  }, React__default.createElement(Col, {
    className: "steppers-header"
  }, React__default.createElement("ul", {
    className: 'mx-5 my-2 d-flex flex-row'
  }, Object.keys(hash_stepper).map(function (key) {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement("li", {
      key: 'list_element_' + key,
      className: class_by_position(key, step_name)
    }, React__default.createElement("p", {
      key: 'stepper_p' + key,
      className: ' my-2'
    }, hash_stepper[key]['label']), hash_stepper[key]['posizione'] < hash_stepper[step_name]['posizione'] && React__default.createElement(Icon, {
      key: 'Icon_element_' + key,
      icon: 'it-check',
      className: 'mx-2 mb-2',
      size: 'lg'
    })));
  })), React__default.createElement("span", {
    className: "steppers-index",
    "aria-hidden": "true"
  }, hash_stepper[step_name]['posizione'], "/", Object.keys(hash_stepper).length))));
};

var Section = function Section(_ref) {
  var _classNames;

  var color = _ref.color,
      image = _ref.image,
      wrapperClassName = _ref.wrapperClassName,
      className = _ref.className,
      children = _ref.children,
      neutral = _ref.neutral,
      muted = _ref.muted,
      rest = _objectWithoutPropertiesLoose(_ref, ["color", "image", "wrapperClassName", "className", "children", "neutral", "muted"]);

  var classes = classNames('section', wrapperClassName === true ? className : wrapperClassName, (_classNames = {}, _classNames["section-" + color] = color, _classNames['section-image'] = image, _classNames));

  if (neutral || muted) {
    notifyDeprecation("Please use the prop \"color\" instead of the \"" + (neutral ? 'neutral' : 'muted') + "\" for the Section component.");
  } // have them separated from the classes above or these will conflict with the color prop
  // concatenate them at the end. Worst case a duplicate class will appear


  var deprecatedClasses = classNames({
    'section-neutral': neutral,
    'section-muted': muted
  });
  var innerClasses = classNames('section-content', className);
  var styleClass = {
    backgroundImageClass: image ? {
      backgroundImage: "url(" + image + ")"
    } : {}
  };
  var finalWrapperClassName = classNames(classes, deprecatedClasses);
  return React__default.createElement("div", Object.assign({
    className: finalWrapperClassName,
    style: styleClass.backgroundImageClass
  }, rest), React__default.createElement("div", {
    className: innerClasses
  }, children));
};

var PositionContext = /*#__PURE__*/createContext(undefined);
function usePosition() {
  var context = useContext(PositionContext);
  return context;
}

var getBorderStyleFix = function getBorderStyleFix(fix) {
  var borderReset = ['top', 'bottom', 'right', 'left'].filter(function (curPosition) {
    return fix === 'left' ? curPosition !== 'right' : curPosition !== 'left';
  }).map(function (borderPosition) {
    return "border" + (borderPosition[0].toUpperCase() + borderPosition.substring(1));
  });
  var customStyle = {};

  for (var _iterator = _createForOfIteratorHelperLoose(borderReset), _step; !(_step = _iterator()).done;) {
    var borderPos = _step.value;
    customStyle[borderPos] = 'none';
  }

  return customStyle;
};

function pickIcon(state) {
  switch (state) {
    case 'error':
      return 'it-close-circle';

    case 'info':
      return 'it-info-circle';

    case 'warning':
      return 'it-error';

    case 'success':
      return 'it-check-circle';

    default:
      return undefined;
  }
}

function NotificationElement(_ref) {
  var _classNames;

  var closeToast = _ref.closeToast,
      toastProps = _ref.toastProps,
      title = _ref.title,
      body = _ref.body,
      options = _ref.options;
  var globalFix = usePosition();
  var userIcon = options.icon,
      state = options.state,
      localFix = options.fix,
      dismissable = options.dismissable;
  var fixPosition = localFix == null && globalFix ? globalFix : localFix || globalFix;
  var autoClose = toastProps.autoClose,
      style = toastProps.style;
  var content = typeof body === 'string' ? React__default.createElement("p", null, body) : body;
  var icon = userIcon || pickIcon(state);
  var borderFixes = getBorderStyleFix(fixPosition);
  var wrapperClass = classNames('notification', state, (_classNames = {}, _classNames[fixPosition + "-fix"] = fixPosition, _classNames['with-icon'] = icon, _classNames.dismissable = dismissable || !autoClose, _classNames)); // Need to override some toast styling here

  var customStyle = _extends({}, style, borderFixes, {
    // force a display as the notification class has a "display: none" set
    display: 'block'
  });

  return React__default.createElement("div", {
    className: wrapperClass,
    style: customStyle
  }, React__default.createElement("h5", null, title, icon ? React__default.createElement(Icon, {
    icon: icon
  }) : null), content, (!autoClose || dismissable) && React__default.createElement(Button, {
    className: 'notification-close',
    onClick: closeToast
  }, React__default.createElement(Icon, {
    icon: 'it-close'
  }), React__default.createElement("span", {
    className: 'visually-hidden'
  }, "Chiudi notifica: ", title)));
}
/**
 * Internal use only. Exported for documentation purposes.
 * @internal
 */


var createNotification = function createNotification(title, body, options, closeToast, toastProps) {
  return React__default.createElement(NotificationElement, {
    title: title,
    body: body,
    options: options,
    closeToast: closeToast,
    toastProps: toastProps
  });
};

var dummyTransition = /*#__PURE__*/cssTransition({
  enter: '',
  exit: ''
});
var Notification = function Notification(props) {
  var _useToast = useToast(_extends({}, props, {
    transition: dummyTransition
  })),
      toastRef = _useToast.toastRef,
      eventHandlers = _useToast.eventHandlers;

  var children = props.children,
      autoClose = props.autoClose,
      onClick = props.onClick,
      role = props.role,
      toastId = props.toastId,
      deleteToast = props.deleteToast,
      closeToast = props.closeToast,
      isIn = props.isIn;
  var customStyle = {
    display: isIn ? 'block' : 'none'
  };
  useEffect(function () {
    if (!isIn) deleteToast(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIn]);
  useEffect(function () {
    var timer;

    if (autoClose) {
      timer = setTimeout(function () {
        return closeToast();
      }, autoClose);
    }

    return function () {
      if (timer != null) {
        clearTimeout(Number(timer));
      }
    };
  }, [autoClose, closeToast]);
  return React__default.createElement("div", Object.assign({
    id: toastId,
    onClick: onClick
  }, eventHandlers, {
    style: customStyle,
    ref: toastRef
  }, isIn && {
    role: role
  }), children);
};

var KitTransition = /*#__PURE__*/cssTransition({
  enter: "d-block",
  exit: "d-none",
  appendPosition: false
});
var NotificationManager = function NotificationManager(props) {
  var _props$duration, _props$closeOnClick;

  var customStyle = _extends({}, props.style, getBorderStyleFix(props.fix));

  var hookProps = {
    autoClose: (_props$duration = props.duration) != null ? _props$duration : 6000,
    closeOnClick: (_props$closeOnClick = props.closeOnClick) != null ? _props$closeOnClick : true,
    hideProgressBar: true,
    transition: KitTransition,
    rtl: false,
    pauseOnHover: true,
    pauseOnFocusLoss: true,
    newestOnTop: false,
    draggable: false,
    role: 'alert',
    style: customStyle,
    enableMultiContainer: props.containerId != null // enable multi container when an explicit id is passed

  };

  var _useToastContainer = useToastContainer(hookProps),
      getToastToRender = _useToastContainer.getToastToRender,
      containerRef = _useToastContainer.containerRef,
      isToastActive = _useToastContainer.isToastActive;

  var containerId = props.containerId,
      style = props.style,
      fix = props.fix;
  return React__default.createElement(PositionContext.Provider, {
    value: fix
  }, React__default.createElement("div", {
    ref: containerRef,
    id: containerId,
    style: style
  }, getToastToRender(function (_, toastList) {
    return toastList.map(function (_ref) {
      var content = _ref.content,
          toastProps = _ref.props;
      return React__default.createElement(Notification, Object.assign({}, toastProps, {
        isIn: isToastActive(toastProps.toastId),
        key: "notification-" + toastProps.key
      }), content);
    });
  })));
};

function notify(title, bodyOrOptions, options) {
  var body = isReactChild(bodyOrOptions) ? bodyOrOptions : undefined;
  var safeOptions = isReactChild(bodyOrOptions) ? _extends({}, options) : bodyOrOptions || {};
  var NotificationContent = createNotification(title, body, safeOptions);

  var internalOptions = _extends({}, safeOptions, {
    autoClose: safeOptions.duration
  });

  return toast(NotificationContent, internalOptions);
}

function isReactChild(el) {
  return el != null && (typeof el === 'string' || typeof el === 'number' || 'type' in el);
}

notify.dismiss = function (id) {
  return toast.dismiss(id);
};

var SizeContext = /*#__PURE__*/createContext(undefined);
var Toolbar = function Toolbar(_ref) {
  var _classnames;

  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'nav' : _ref$tag,
      size = _ref.size,
      children = _ref.children,
      vertical = _ref.vertical,
      attributes = _objectWithoutPropertiesLoose(_ref, ["tag", "size", "children", "vertical"]);

  var Tag = tag;
  var classes = classNames('toolbar', (_classnames = {}, _classnames["toolbar-" + size] = size && size !== 'large', _classnames['toolbar-vertical'] = vertical, _classnames));
  return React__default.createElement(SizeContext.Provider, {
    value: size || 'large'
  }, React__default.createElement(Tag, Object.assign({
    className: classes
  }, attributes), React__default.createElement("ul", null, children)));
};

var disabledMessage = ' elemento disabilitato';

function ToolbarItemLabel(_ref) {
  var label = _ref.label,
      size = _ref.size,
      disabled = _ref.disabled,
      badge = _ref.badge;
  var showSrText = size && size !== 'large';

  if (disabled) {
    if (!label || showSrText) {
      return React__default.createElement("span", {
        className: 'sr-only'
      }, disabledMessage);
    }

    return React__default.createElement(React__default.Fragment, null, React__default.createElement("span", {
      className: 'toolbar-label'
    }, label), React__default.createElement("span", {
      className: 'sr-only'
    }, disabledMessage));
  }

  if (!label) {
    return null;
  }

  return showSrText ? React__default.createElement("span", {
    className: 'sr-only'
  }, label) : React__default.createElement("span", {
    className: 'toolbar-label'
  }, label, badge != null && badge.label ? React__default.createElement("span", {
    className: 'sr-only'
  }, badge.label) : null);
}

var ToolbarItem = function ToolbarItem(_ref2) {
  var _ref2$active = _ref2.active,
      active = _ref2$active === void 0 ? false : _ref2$active,
      badge = _ref2.badge,
      url = _ref2.url,
      iconName = _ref2.iconName,
      label = _ref2.label,
      _ref2$tag = _ref2.tag,
      tag = _ref2$tag === void 0 ? 'a' : _ref2$tag,
      disabled = _ref2.disabled,
      srText = _ref2.srText,
      dropdown = _ref2.dropdown,
      dropdownProps = _ref2.dropdownProps,
      children = _ref2.children,
      showMore = _ref2.showMore,
      onClick = _ref2.onClick,
      isDropdownOpen = _ref2.isDropdownOpen,
      attributes = _objectWithoutPropertiesLoose(_ref2, ["active", "badge", "url", "iconName", "label", "tag", "disabled", "srText", "dropdown", "dropdownProps", "children", "showMore", "onClick", "isDropdownOpen"]);

  var Tag = tag;
  var size = useContext(SizeContext);
  var activeClass = classNames({
    active: active,
    disabled: disabled
  });

  var ariaAttributes = _extends({}, disabled && {
    'aria-disabled': true
  });

  var badgeObject = typeof badge === 'number' ? {
    value: badge,
    label: srText || '',
    srText: srText || ''
  } : badge;
  var toolbarItemContent = React__default.createElement(React__default.Fragment, null, badgeObject ? React__default.createElement("div", {
    className: 'badge-wrapper'
  }, React__default.createElement("span", {
    className: 'toolbar-badge'
  }, size !== 'large' ? null : badgeObject.value), size !== 'large' && React__default.createElement("span", {
    className: 'sr-only'
  }, badgeObject.srText)) : null, React__default.createElement(Icon, {
    icon: iconName,
    size: size === 'small' ? 'sm' : ''
  }), React__default.createElement(ToolbarItemLabel, {
    label: label,
    size: size,
    disabled: disabled,
    badge: badgeObject
  }));

  if (dropdown) {
    return React__default.createElement("li", null, React__default.createElement(Dropdown, Object.assign({}, dropdownProps, {
      toggle: onClick,
      isOpen: isDropdownOpen
    }), React__default.createElement(DropdownToggle, {
      disabled: disabled,
      caret: true,
      className: classNames('btn-dropdown', {
        'toolbar-more': showMore
      }),
      color: ''
    }, toolbarItemContent), children));
  }

  return React__default.createElement("li", null, React__default.createElement(Tag, Object.assign({
    href: url || '#',
    className: activeClass
  }, attributes, ariaAttributes, {
    onClick: onClick
  }), toolbarItemContent));
};

var ToolbarDividerItem = function ToolbarDividerItem() {
  return React__default.createElement("li", {
    className: 'toolbar-divider',
    "aria-hidden": true
  });
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var FeedbackInputText = function FeedbackInputText(props) {
  var onChangeHandler = function onChangeHandler(e) {
    var note = e.currentTarget.value;
    props.setFields(_extends({}, props.fields, {
      note: note
    }));
  };

  return React__default.createElement("fieldset", null, React__default.createElement(Input, {
    label: 'Vuoi aggiungere altri dettagli ?',
    type: 'text',
    placeholder: '',
    id: 'examplePlaceholder',
    infoText: 'inserire massimo 200 caratteri',
    maxLength: 200,
    "aria-describedby": 'formGroupExampleInputWithHelpDescription',
    onChange: onChangeHandler,
    "data-element": "feedback-input-text"
  }));
};

var FeedbackOutput = function FeedbackOutput() {
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(CardTitle$1, {
    tag: 'h5',
    className: 'title-medium-2-bold mb-0'
  }, "Grazie ! Il tuo parere ci aiuter\xE0 a migliorare il servizio"));
};

var FeedbackSelect = function FeedbackSelect(props) {
  var onChangeHandler = function onChangeHandler(e) {
    e.currentTarget.defaultChecked = true;
    var elementoSelezionato = e.currentTarget.value;
    props.setFields(_extends({}, props.fields, {
      elementoSelezionato: elementoSelezionato
    }));
  };

  var giudizioPositivo = props.rating > 3;

  var domande = function domande(props, giudizioPositivo) {
    var domande = props.setup.domande;
    if (domande == null) domande = {
      positiva: 'Quali sono gli aspetti che hai preferito? ',
      negativa: 'Dove hai incontrato maggiori difficoltà ?'
    };
    return giudizioPositivo ? domande.positiva : domande.negativa;
  };

  var risposte = function risposte(props, giudizioPositivo) {
    var risposte = props.setup.rispostePossibili;
    if (risposte == null) risposte = {
      negative: [['01', 'A volte le indicazioni non erano chiare'], ['02', 'A volte le indicazioni non erano complete'], ['03', 'A volte non capivo se stavo procedendo correttamente'], ['04', 'Ho avuto problemi tecnici'], ['05', 'Altro']],
      positive: [['11', 'Le indicazioni erano chiare'], ['12', 'Le indicazioni erano complete'], ['13', 'Capivo sempre che stavo procedendo correttamente'], ['14', 'Non ho avuto problemi tecnici'], ['15', 'Altro']]
    };
    return giudizioPositivo ? risposte.positive : risposte.negative;
  };

  return React__default.createElement("fieldset", {
    "data-element": giudizioPositivo ? 'feedback-rating-positive' : 'feedback-rating-negative'
  }, React__default.createElement("div", {
    className: 'p-3'
  }, React__default.createElement("legend", {
    className: 'd-block d-lg-inline',
    "data-element": "feedback-rating-question"
  }, React__default.createElement(CardTitle, {
    className: 'text-wrap',
    tag: 'h5'
  }, domande(props, giudizioPositivo))), React__default.createElement("div", {
    className: 'p-3 ms-4'
  }, risposte(props, giudizioPositivo).map(function (risposta) {
    return React__default.createElement(FormGroup, {
      check: true,
      key: risposta[0],
      className: 'form-check-group'
    }, React__default.createElement(Input, {
      name: 'gruppo0',
      type: 'radio',
      id: risposta[0],
      onChange: onChangeHandler,
      value: risposta[0],
      defaultChecked: risposta[0].localeCompare(props.fields.elementoSelezionato) === 0
    }), React__default.createElement(Label, {
      check: true,
      htmlFor: risposta[0],
      "data-element": "feedback-rating-answer"
    }, risposta[1]));
  }))));
};

var TipologiaPagina;

(function (TipologiaPagina) {
  TipologiaPagina["servizio"] = "Quanto \xE8 stato facile usare questo servizio ?";
  TipologiaPagina["informativa"] = "Quanto sono chiare le informazioni in questa pagina?";
})(TipologiaPagina || (TipologiaPagina = {}));

var FormFeedback = function FormFeedback(props) {
  return React__default.createElement(Form, {
    onSubmit: props.onSubmitHandler
  }, React__default.createElement("span", null, props.step !== 3 && React__default.createElement(React__default.Fragment, null, React__default.createElement(CardHeader, {
    className: 'border-0'
  }, React__default.createElement("h2", {
    className: 'title-medium-2-semi-bold mb-0',
    "data-element": 'feedback-title'
  }, props.tipoPagina === 'informativa' ? TipologiaPagina.informativa : TipologiaPagina.servizio)), React__default.createElement(CardBody, null, React__default.createElement(Rating, {
    value: props.rating,
    inputs: props.idStelline == null ? ['star1f', 'star2f', 'star3f', 'star4f', 'star5f'] : props.idStelline,
    name: 'ratingFeedback',
    onChangeRating: function onChangeRating(valutazione) {
      props.setStep(1);
      props.setRating(valutazione);
      props.setFields(_extends({}, props.fields, {
        valutazione: valutazione
      }));
    },
    legend: {
      content: "Rating",
      srOnly: true
    }
  }))), props.step === 1 && React__default.createElement(CardBody, null, React__default.createElement(FeedbackSelect, {
    fields: props.fields,
    setFields: props.setFields,
    step: props.step,
    stepForward: props.forwardStep,
    rating: props.rating,
    setup: props
  })), props.step === 2 && React__default.createElement(CardBody, null, React__default.createElement(FeedbackInputText, {
    fields: props.fields,
    setFields: props.setFields
  })), props.step === 3 && React__default.createElement(FeedbackOutput, null), React__default.createElement("div", {
    className: props.step !== 0 && props.step !== 3 ? 'd-flex flex-nowrap pt-4 w-100 justify-content-center button-shadow' : ''
  }, props.step !== 0 && props.step !== 3 && props.step !== 1 && React__default.createElement(Button, {
    onClick: props.backStep,
    className: 'btn btn-outline-primary fw-bold me-4 btn-back'
  }, "Indietro"), React__default.createElement(Button, {
    type: 'submit',
    onSubmit: props.forwardStep,
    className: 'btn btn-primary fw-bold btn-next',
    hidden: props.step === 0 || props.step === 3
  }, "Avanti"))));
};

var Feedback = function Feedback(props) {
  var _useState = useState(0),
      rating = _useState[0],
      setRating = _useState[1];

  var _useState2 = useState(0),
      step = _useState2[0],
      setStep = _useState2[1];

  var _useState3 = useState({
    elementoSelezionato: ''
  }),
      fields = _useState3[0],
      setFields = _useState3[1];

  var forwardStep = function forwardStep() {
    setStep(step + 1);
  };

  var backStep = function backStep() {
    setStep(step - 1);
  };

  useEffect(function () {
    if (step === 1) {
      if (props.funzioneInvio == null && props.parametri != null) setFields(_extends({}, fields));
    }

    if (step > 4 || step < 0) {
      setStep(0);
    }

    if (step === 3) {
      console.log('fields 1', fields);
      if (props.funzioneInvio == null && props.parametri != null) invioDefaultFeedback(fields, props.parametri);else if (props.funzioneInvio != null) props.funzioneInvio(fields);
    }
  }, [step]);

  var onSubmitHandler = function onSubmitHandler(e) {
    e.preventDefault();
    forwardStep();
  };

  if (props.small) {
    return React__default.createElement(Card, {
      spacing: true,
      className: 'card-bg p-3'
    }, React__default.createElement(FormFeedback, {
      backStep: backStep,
      fields: fields,
      forwardStep: forwardStep,
      onSubmitHandler: onSubmitHandler,
      onsubmit: onSubmitHandler,
      rating: rating,
      setFields: setFields,
      setRating: setRating,
      setStep: setStep,
      step: step,
      tipoPagina: props.tipoPagina,
      domande: props.domande,
      funzioneInvio: props.funzioneInvio,
      idStelline: props.idStelline,
      parametri: props.parametri,
      rispostePossibili: props.rispostePossibili,
      small: props.small
    }));
  }

  return React__default.createElement("div", {
    className: 'bg-primary',
    "data-element": "feedback"
  }, React__default.createElement("div", {
    className: 'container'
  }, React__default.createElement("div", {
    className: 'row d-flex justify-content-center bg-primary'
  }, React__default.createElement("div", {
    className: 'col-12 col-lg-8 p-lg-0 px-4'
  }, React__default.createElement("div", {
    className: 'pt-3 pt-lg-80 pb-lg-80'
  }, React__default.createElement(Card, {
    spacing: true,
    className: 'card-bg p-3'
  }, step !== 3 && props.tipoPagina !== 'informativa' && React__default.createElement(CardTitle$1, {
    tag: 'p',
    className: 'fw-bold'
  }, "Al termine delle operazioni, se vuoi, ti chiediamo pochi secondi del tuo tempo per esprimere la tua opinione sulla semplicit\xE0 dei nostri servizi online."), React__default.createElement(FormFeedback, {
    backStep: backStep,
    fields: fields,
    forwardStep: forwardStep,
    onSubmitHandler: onSubmitHandler,
    onsubmit: onSubmitHandler,
    rating: rating,
    setFields: setFields,
    setRating: setRating,
    setStep: setStep,
    step: step,
    tipoPagina: props.tipoPagina,
    domande: props.domande,
    funzioneInvio: props.funzioneInvio,
    idStelline: props.idStelline,
    parametri: props.parametri,
    rispostePossibili: props.rispostePossibili,
    small: props.small
  })))))));
};

function invioDefaultFeedback(_x, _x2) {
  return _invioDefaultFeedback.apply(this, arguments);
}

function _invioDefaultFeedback() {
  _invioDefaultFeedback = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(feedback, parametriInvio) {
    var urlInvioFeedback, servizio, dominioEnte, clientID, codiceFiscaleEnte, tipologiaServizio, response, data;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            urlInvioFeedback = parametriInvio.urlInvioFeedback, servizio = parametriInvio.servizio, dominioEnte = parametriInvio.dominioEnte, clientID = parametriInvio.clientID, codiceFiscaleEnte = parametriInvio.codiceFiscaleEnte, tipologiaServizio = parametriInvio.tipologiaServizio;
            _context.next = 3;
            return window.fetch(urlInvioFeedback, {
              method: 'POST',
              headers: {
                'content-type': 'application/json;charset=UTF-8'
              },
              body: JSON.stringify(_extends({}, feedback, {
                servizio: servizio,
                dominioEnte: dominioEnte,
                clientID: clientID,
                codiceFiscaleEnte: codiceFiscaleEnte,
                linkServizio: document.location.href,
                tipologiaServizio: tipologiaServizio
              }))
            });

          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.json();

          case 6:
            data = _context.sent;

            if (response.ok) {
              if (data) {
                console.log(data);
              }
            }

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _invioDefaultFeedback.apply(this, arguments);
}

var FlashAlert = function FlashAlert(_ref) {
  var _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      props = _objectWithoutPropertiesLoose(_ref, ["visible"]);

  var id = 'modalFlashAlert' + Math.round(Math.random() * 100);
  var styleArray = {
    overflow: 'auto',
    maxHeight: '500px'
  };
  return createElement(Fragment, null, visible && props.mode === 'flash' && Object.keys(props.flash).map(function (tipoMessaggio) {
    return createElement(Fragment, null, isType(props.flash[tipoMessaggio], 'array') && createElement(Fragment, null, createElement(Alert, {
      key: getKey(tipoMessaggio.toString().replace('Msg', '')),
      color: tipoMessaggio.toString().replace('Msg', ''),
      style: styleArray
    }, props.flash[tipoMessaggio].map(function (messaggio) {
      return createElement("div", {
        key: getKey(tipoMessaggio.toString().replace('Msg', ''))
      }, createElement("div", {
        className: 'd-flex my-2 ' + props.className
      }, messaggio), createElement("hr", null));
    }))), isType(props.flash[tipoMessaggio], 'string') && createElement(Alert, {
      key: getKey(tipoMessaggio.toString().replace('Msg', '')),
      color: tipoMessaggio.toString().replace('Msg', ''),
      className: props.className
    }, props.flash[tipoMessaggio]));
  }), props.mode === 'modale' && visible && createElement(Modal, {
    isOpen: visible,
    withIcon: true,
    labelledBy: id,
    color: 'info'
  }, createElement(ModalHeader, {
    className: 'mx-auto',
    id: id
  }, Object.keys(props.flash).map(function (tipoMessaggio) {
    return createElement("div", {
      key: getKey(tipoMessaggio.toString().replace('Msg', ''))
    }, isType(props.flash[tipoMessaggio], 'array') && createElement(Fragment, null, createElement(Alert, {
      key: getKey(tipoMessaggio.toString().replace('Msg', '')),
      color: tipoMessaggio.toString().replace('Msg', ''),
      className: 'my-2 ',
      style: styleArray
    }, props.flash[tipoMessaggio].map(function (messaggio) {
      return createElement("div", {
        key: getKey(tipoMessaggio.toString().replace('Msg', ''))
      }, createElement("div", {
        className: 'd-flex my-2 ' + props.className
      }, messaggio), createElement("hr", null));
    }))), isType(props.flash[tipoMessaggio], 'string') && createElement(Alert, {
      key: getKey(tipoMessaggio.toString().replace('Msg', '')),
      color: tipoMessaggio.toString().replace('Msg', '')
    }, props.flash[tipoMessaggio]));
  })), createElement(ModalFooter, null, createElement(Button, {
    color: 'primary',
    onClick: function onClick() {
      return props.toggle == null ? void 0 : props.toggle(!visible);
    }
  }, "Ok"))), visible && props.mode === 'notifica' && Object.keys(props.flash).map(function (tipoMessaggio) {
    if (isType(props.flash[tipoMessaggio], 'array')) {
      notify(tipoMessaggio.toString().replace('Msg', ''), createElement(Alert, {
        key: getKey(tipoMessaggio.toString().replace('Msg', '')),
        color: tipoMessaggio.toString().replace('Msg', ''),
        className: 'my-2 ',
        style: styleArray
      }, props.flash[tipoMessaggio].map(function (messaggio) {
        return createElement("div", {
          key: getKey(tipoMessaggio.toString().replace('Msg', ''))
        }, createElement("div", {
          className: 'd-flex my-2 ' + props.className
        }, messaggio), createElement("hr", null));
      })), {
        duration: 0
      });
    }

    if (isType(props.flash[tipoMessaggio], 'string')) {
      notify(tipoMessaggio.toString().replace('Msg', ''), createElement(Alert, {
        key: getKey(tipoMessaggio.toString().replace('Msg', '')),
        color: tipoMessaggio.toString().replace('Msg', '')
      }, props.flash[tipoMessaggio]), {
        duration: 0
      });
    }
  }) && createElement(NotificationManager, {
    closeOnClick: false,
    duration: 0,
    fix: 'left'
  }));
};

var capitalizeFirstLetter = function capitalizeFirstLetter(txt) {
  return txt.charAt(0).toUpperCase() + txt.slice(1);
};

var isType = function isType(x, typeToCheck) {
  return Object.prototype.toString.call(x) === '[object ' + capitalizeFirstLetter(typeToCheck) + ']';
};

var getKey = function getKey(tipo) {
  return 'key ' + tipo + ' ' + Math.round(Math.random() * 100).toString();
};

var IntegrationHeader = function IntegrationHeader(props) {
  var inizioHeader = /<header/;
  var fineHeader = /<\/header>/;

  var _useState = useState(''),
      header = _useState[0],
      setHeader = _useState[1];

  var urlFetch = 'https://portale-pnrr.parsec326.cloud/ws-header-esterno/';

  if (props.urlFetch) {
    urlFetch = props.urlFetch;
  }

  if (!header) {
    fetch(urlFetch).then(function (response) {
      return response.text();
    }).then(function (text) {
      var headerTmp = text.slice(text.search(inizioHeader), text.search(fineHeader));
      setHeader(headerTmp);
    });
  }

  var _useState2 = useState(false),
      rightZoneCorrected = _useState2[0],
      setRightZoneCorrected = _useState2[1];

  var _useState3 = useState(false),
      svgImported = _useState3[0],
      setSvgImported = _useState3[1];

  var handleClickBurger = function handleClickBurger() {
    var nav = document.querySelector('#nav4');

    if (nav) {
      nav.classList.add('expanded');
      nav.style.display = "block";
      var overlay = nav.querySelector('.overlay');

      if (overlay) {
        overlay.classList.add('show');
        overlay.style.display = "block";
      }
    }
  };

  var handleCloseBig = function handleCloseBig() {
    var nav = document.querySelector('#nav4');

    if (nav) {
      nav.classList.remove('expanded');
      nav.style.display = "none";
      var overlay = nav.querySelector('.overlay');

      if (overlay) {
        overlay.classList.remove('show');
        overlay.style.display = "none";
        overlay.addEventListener('click', function () {
          return handleCloseBig();
        });
      }
    }
  };

  useEffect(function () {
    if (!rightZoneCorrected) {
      var parsecRightzone = document.querySelector('.it-header-slim-right-zone, .header-slim-right-zone');

      if (parsecRightzone) {
        var _props$user;

        parsecRightzone.innerHTML = '';
        render(createElement(Fragment, null, createElement(HeaderRightZone, null, createElement(LoginButton, {
          user: (_props$user = props.user) != null ? _props$user : undefined,
          userLogged: props.userLogged,
          navigazioneReact: props.navigazioneReact,
          baseUrl: props.baseUrl,
          logOutUrl: props.logOutUrl,
          turboLinksDisabled: props.turboLinksDisabled
        }))), parsecRightzone);
        setRightZoneCorrected(!rightZoneCorrected);
      }

      var bottoneBurger = document.querySelector('button.custom-navbar-toggler');
      var bottoneCloseDiv = document.querySelector('button.btn.close-menu');
      var overlay = document.querySelector('#nav4 .overlay');

      if (bottoneBurger) {
        bottoneBurger.addEventListener('click', function () {
          return handleClickBurger();
        });
      }

      if (bottoneCloseDiv) {
        bottoneCloseDiv.addEventListener('click', function () {
          return handleCloseBig();
        });
      }

      if (overlay) {
        overlay.addEventListener('click', function () {
          return handleCloseBig();
        });
      }
    }

    if (!svgImported) {
      var elementiSvg = document.querySelectorAll('.it-nav-wrapper svg:not(.it-brand-wrapper svg');
      aggiornaIcone(elementiSvg, setSvgImported, svgImported, ['icon']);
    }
  }, [header, rightZoneCorrected]);
  return createElement(Fragment, null, parse(header));
};
var aggiornaIcone = function aggiornaIcone(elementi, aggionamentoState, state, classiIcone) {
  var aggiornato = false;

  if (elementi) {
    elementi.forEach(function (elemenSvg) {
      var useElement = elemenSvg.querySelector('use');
      var imageElement = elemenSvg.querySelector('image');
      var elemento = useElement ? useElement : imageElement;

      if (elemento) {
        var daModificare = true;
        classiIcone.forEach(function (stringa) {
          daModificare = daModificare && elemenSvg.classList.contains(stringa);
        });

        if (daModificare) {
          var href = elemento.href.baseVal;
          var svg = href.split('#')[1];
          elemenSvg.innerHTML = '';

          if (!aggiornato) {
            aggiornato = true;
          }

          render(createElement(Icon, {
            icon: svg
          }), elemenSvg);
        }
      }
    });
  }

  if (aggiornato) {
    aggionamentoState(!state);
  }
};

var IntegrationFooter = function IntegrationFooter(props) {
  var inizioFooter = /<footer/;
  var fineFooter = /<\/footer>/;

  var _useState = useState(''),
      footer = _useState[0],
      setFooter = _useState[1];

  var _useState2 = useState(false),
      svgImported = _useState2[0],
      setSvgImported = _useState2[1];

  var urlFetch = 'https://portale-pnrr.parsec326.cloud/ws-footer-esterno/';

  if (props.urlFetch) {
    urlFetch = props.urlFetch;
  }

  if (!footer) {
    fetch(urlFetch).then(function (response) {
      return response.text();
    }).then(function (text) {
      var footerTmp = text.slice(text.search(inizioFooter), text.search(fineFooter));
      setFooter(footerTmp);
    });
  }

  useEffect(function () {
    if (!svgImported) {
      var _document$querySelect;

      var elementiSvg = document.querySelectorAll('.it-footer-main svg:not(.it-brand-wrapper svg ');
      aggiornaIcone(elementiSvg, setSvgImported, svgImported, ['icon', 'icon-sm']); //Assegno la classe icon per logo dei comuni per compatibilità con il tema wordpress 

      (_document$querySelect = document.querySelector('footer .it-brand-wrapper svg image')) == null ? void 0 : _document$querySelect.classList.add('icon');
    }
  });
  return createElement(Fragment, null, parse(footer));
};

var TabMenu = function TabMenu(_ref) {
  var headerLinks = _ref.headerLinks,
      navigazioneReact = _ref.navigazioneReact,
      baseUrl = _ref.baseUrl,
      pageSelected = _ref.pageSelected;

  var _useState = useState(pageSelected != null ? pageSelected : ''),
      pagina = _useState[0];

  return React__default.createElement("div", null, React__default.createElement(Nav$1, {
    tabs: true,
    className: 'mb-3 row'
  }, headerLinks == null ? void 0 : headerLinks.map(function (elem) {
    return React__default.createElement(NavItem, {
      className: "col"
    }, navigazioneReact ? React__default.createElement(NavLink, {
      className: elem.label === pagina ? "nav-link active" : "nav-link",
      to: elem.link
    }, elem.element ? elem.element : elem.label) : React__default.createElement("a", {
      className: elem.label === pagina ? "nav-link active" : "nav-link",
      href: baseUrl + elem.link
    }, elem.element ? elem.element : elem.label));
  })));
};

export { Accordion, AccordionBody, AccordionHeader, AccordionItem, Alert, AvatarContainer, AvatarExtraText, AvatarGroupContainer, AvatarIcon, AvatarPresence, AvatarStatus, AvatarWrapper, Badge, BottomNav, BottomNavItem, Breadcrumb, Button, Callout, CalloutText, CalloutTitle, Card, CardBody, CardCategory, CardFooterCTA, CardReadMore, CardSignature, CardTag, CardTagsHeader, CardText, CardTitle, Chip, ChipLabel, Collapse, CookieBar, CookieBarButton, CookieBarButtons, Dimmer, DimmerButtons, Feedback, FlashAlert, FontLoader, Footer, Forward, FullHeader, GridItem, GridItemText, GridItemTextWrapper, GridList, GridRow, Header, HeaderBrand, HeaderContent, HeaderLinkZone, HeaderRightZone, HeaderSearch, HeaderSocialsZone, HeaderToggler, Headers, Hero, HeroBackground, HeroBody, HeroButton, HeroCategory, HeroTitle, Icon, Input, InputContainer, IntegrationFooter, IntegrationHeader, LinkList, LinkListItem, Loader, Megamenu, MegamenuFooter, MegamenuHighlightColumn, MegamenuItem, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NotificationManager, Pager, PointList, PointListAside, PointListBody, PointListContent, Progress, Rating, ResponsiveImage, Section, Select, Sidebar, Skiplink, SkiplinkItem, Spinner, StepperComponent, StepperContainer, StepperContent, StepperDots, StepperHeader, StepperHeaderElement, StepperNav, TabMenu, TextArea, ThumbNav, ThumbNavItem, TimeInput, Timeline, TimelinePin, Toggle, Toolbar, ToolbarDividerItem, ToolbarItem, clearIconCache, createNotification, iconsList as icons, notify, preloadIcons, useFontLoader };
//# sourceMappingURL=index.js.map
